<template>
    <div class="constels_page">
        <div class="top_content">
            <header v-if="isWeaWvFullScreen">
                <div class="top_pad" :style="{ height: `${statusHeight}px` }"></div>
                <ul class="controls_container">
                    <li class="header_left_col">
                        <div class="header_back" @click="handleHeaderBackClick()"></div>
                        <div>观天识星</div>
                    </li>
                    <li class="header_right_col" @click="handleHeaderMenuClick()">
                        <div class="menu_list" :style="{ display: `${showMenu}` }">
                            <div class="menu_item" @click.stop="handleShareClick()">分享</div>
                            <div class="menu_item" @click.stop="handleRefreshClick()">
                                刷新
                            </div>
                        </div>
                    </li>
                </ul>
            </header>

            <div class="search_btn_container">
                <div class="search_input_col" @click="handleSearchClick()">
                    <div class="search_icon"></div>
                    <div class="search_text">{{ searchPhl }}</div>
                </div>

                <div :class="['ar_btn', { allow_ar: this.orientation }]" @click="handleToggleArClick"></div>
                <div class="menu_btn" @click="handleMenuClick">
                    <ul class="bottom_btn_container" :style="{ display: showTopMenu }">
                        <li class="stargaze_btn" id="stargaze_btn" @click.stop="handleMenuBtnClick('stargaze_btn')">
                            <div class="icon"></div>
                            <div class="label">观星预报</div>
                        </li>
                        <li class="solar_terms_btn" id="solar_terms_btn"
                            @click.stop="handleMenuBtnClick('solar_terms_btn')">
                            <div class="icon"></div>
                            <div class="label">24节气</div>
                        </li>
                        <li class="constels_btn" id="constels_btn" @click.stop="handleMenuBtnClick('constels_btn')">
                            <div class="icon"></div>
                            <div class="label">星座运势</div>
                        </li>
                        <li class="ap_btn" id="ap_btn" @click.stop="handleMenuBtnClick('ap_btn')">
                            <div class="icon"></div>
                            <div class="label">天文现象</div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <!--绘制canvas的盒子-->
        <div id="constel_canvas"></div>

        <!-- 旋转取消、点击其它区域取消当前 -->
        <div ref="constelInfoPopup" class="constel_info_popup_container" v-if="showConstelInfoPopup"
            :style="constelInfoPopupCss">
            <div class="close_info_icon" @click="handleCloseConstelClick()"></div>
            <div class="info_header">
                <div>{{ clickedConstel.name }}</div>
            </div>
            <div class="latin_name_row">{{ clickedConstel.latinName }}</div>
            <ul class="constel_info_list">
                <li class="info_row">
                    <div class="info_label">
                        <div>赤</div>
                        <div>经 :</div>
                    </div>
                    <div class="info_content">{{ clickedConstel.raRange }}</div>
                </li>
                <li class="info_row">
                    <div class="info_label">
                        <div>赤</div>
                        <div>纬 :</div>
                    </div>
                    <div class="info_content">{{ clickedConstel.decRange }}</div>
                </li>
                <li class="info_row">
                    <div class="info_label">
                        <div>象</div>
                        <div>征</div>
                        <div>物 :</div>
                    </div>
                    <div class="info_content">{{ clickedConstel.symbol }}</div>
                </li>
                <li class="info_row">
                    <div class="info_label">
                        <div>面</div>
                        <div>积 :</div>
                    </div>
                    <div class="info_content">{{ clickedConstel.area }}</div>
                </li>
                <li class="info_row">
                    <div class="info_label">所含星数 :</div>
                    <div class="info_content">{{ clickedConstel.containedStars }}</div>
                </li>
                <li class="info_row">
                    <div class="info_label">最佳观测月份 :</div>
                    <div class="info_content">{{ clickedConstel.bestObs }}</div>
                </li>
            </ul>
            <div class="view_more_btn" @click="handleViewMoreInfoClick">
                <div class="btn_text">查看更多</div>
                <div class="btn_icon"></div>
            </div>
        </div>

        <div class="dialog" v-if="showDialog">{{ dialogMsg }}</div>

        <div class="test_btns_container" v-show="showTestBtns">
            <div v-if="false" class="" @click="handleScreenClick()">全屏按钮</div>
            <div v-if="false" class="" @click="handleOutputClick()">输出按钮</div>
            <div v-if="false" class="orientation_btn" @click="handleToggleOientation()">
                {{ cameraFov }}
            </div>
        </div>
        <!-- <div id="direction">等待获取手机方向...</div> -->
    </div>
</template>
<script>
import * as THREE from "three"; // THREE.REVISION：142
import { FontLoader } from "three/examples/jsm/loaders/FontLoader.js";
import { TextGeometry } from "three/examples/jsm/geometries/TextGeometry.js";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls"; // 鼠标控制

import utils from "../utils/index.js";
import Toucher from "../utils/toucher.js";
import Orienter from "../utils/orienter.js";
import generalConst from "../constant/general.js";
import constelsData from "../constant/constelsData.js"; // 星座数据
import constelsIconArgs from "../constant/constelsIconArgs.js"; // 图标的调整参数

import universeBg from "../assets/images/constels/background/universe_new1.jpg"; // 宇宙
import starBg from "../assets/images/constels/background/ic_star_dark.png"; // 星辰默认状态
import starSelectedBg from "../assets/images/constels/background/ic_star_bright.png"; // 星辰选中状态
import directionIcon from "../assets/images/constels/icon/ic_star_direction_north@2x.png"; // 星辰选中状态

let scene = null; // 场景(频繁变更的对象放置在vue的data中会导致卡顿)
let camera = null; // 相机
let orbitControls = null; // 鼠标控件
window.distanceObj = {};

export default {
    props: {},
    components: {},
    data() {
        return {
            constels: constelsData.constels,
            dom: "", //需要使用canvas的dom
            domWidth: 0,
            domHeight: 0,
            renderer: "", //渲染器
            anId: null, //动画id
            orientation: false, // 是否开启方向事件
            allowOrientation: false, // 方向事件节流开关
            isRevolution: true, //公转状态
            isRotation: true, //自转状态
            raycaster: new THREE.Raycaster(), // 光线投射器(用于鼠标点击时获取坐标)
            mouse: new THREE.Vector2(), // 鼠标点击的二维平面
            initStarSize: 100, // 星星的大小
            // universeRadius: 1000000, // 宇宙半径
            universeRadius: 20000,
            farPlane: 1000000, // 相机远面
            // fov: 60,
            fov: 100, // 会影响到threejs创建的所有东西，包括星星，星座，文字等，所以需要调整，不然会出现星星太大，文字太小的情况
            rotateSpeed: 0.1, // orbit控制器旋转速度
            initialOrientation: null, // 保存初始方向
            constelTargetCoord: {},
            clickNum: 0,
            starObjList: [], // 所有星星组成的数组
            lastZoom: null,
            addedConstel: [],
            searchPhl: "搜索星座",
            showConstelInfoPopup: false,
            clickedConstel: {
                name: "",
                starsOrigin: [],
            }, // 点击选中的星座
            constelInfoPopupCss: {},
            controlsMinDistance: 60,// 相机最小距离
            controlsMaxDistance: 6600,// 相机最大距离
            showTestBtns: true,// 测试按钮
            isWeaWvFullScreen: false,// 是否全屏
            showTopMenu: "none",//    // 顶部菜单
            showMenu: "none",
            // statusHeight: 24,
            statusHeight: 0,// 状态栏高度
            initTarget: [0, 0, 1000], // 原为[0, 0, 1]，为了初始化时可放大，使用当前值。
            alpha: 0,// 设备方向，弧度，0~2π，初始为0
            beta: "",// 设备方向，弧度，-π/2~π/2，初始为0
            gamma: 0,
            x: 0,
            y: 0,
            z: 0,
            dAlpha: 0,
            dBeta: 0,
            dGamma: 0,
            config_: {},
            fix_: {},
            touch_: {},
            orient_: {},
            controlsEnable: false, // 启用控制器
            cameraTarget: {},
            cameraFov: 0,
            unOperated: true, // 用户还未操作过
            directionCoords: [],
            _intFrame: null, // 动画id
            dialogMsg: "",
            showDialog: false,
            isAppH5: false,
            //经纬度默认北京
            location: {
                latitude: 39.9042,
                longitude: 116.4074,
            },
            //是否拖动
            isDrag: false,
            isFirst: true,//是否第一次进入
            alpha: 0
        };
    },
    computed: {
        routeQuery() {
            // 通过query配置的路由
            return this.$route.query;
        },
    },
    watch: {
        showMenu(val, oldVal) {
            if (val === "flex") {
                this.toggleTopMenu("none");
            }
        },
        showTopMenu(val, oldVal) {
            if (val === "flex") {
                this.toggleHeaderMenu("none");
            }
        },
        orientation(val, oldVal) {
            if (val) {
                this.showDialog = true;
                this.dialogMsg = "AR功能已经打开";
                this.isDrag = true;
            } else {
                this.showDialog = true;
                this.dialogMsg = "AR功能已经关闭";
            }

            setTimeout(() => {
                this.showDialog = false;
                this.dialogMsg = "";
            }, 1000);
        },
    },
    created() {
        if (this.$route.query.partner == '18043c3a4dc002fb339ade933d11bdee' || this.$route.query.partner == 'd83221a9b1fab8ef61b83ce218851406') {
            this.isAppH5 = true;
        }

        this.farPlane = this.universeRadius + 5000;

        const radiusValue = this.universeRadius * 0.04;
        // 北：-半径,0,0；南：+半径,0,0；东：0,0,-半径；西：0,0,+半径
        // this.directionCoords = [
        //   {
        //     id: "north",
        //     name: "北    ", // 空格为占位符，不能删除
        //     position: [radiusValue, 0, 0],
        //   },
        //   {
        //     id: "south",
        //     name: "南    ",
        //     position: [-radiusValue, 0, 0],
        //   },
        //   {
        //     id: "east",
        //     name: "东    ",
        //     position: [0, 0, -radiusValue],
        //   },
        //   {
        //     id: "west",
        //     name: "西    ",
        //     position: [0, 0, radiusValue],
        //   },
        // ];
        console.log("this.directionCoords", this.directionCoords);

    },
    beforeMount() {
        this.statusHeight = utils.jsbGetStatusHeight();

        // 自定义title
        // this.isWeaWvFullScreen = utils.isWeaWebview();

        this.initClientShare();
    },
    async mounted() {
        console.log("mounted");
        // 检查浏览器是否支持设备方向事件
        if (window.DeviceOrientationEvent) {
            window.addEventListener('deviceorientation', (event) => {
                // 获取设备的alpha值（手机的朝向，单位是度）
                let alpha = event.alpha;

                // 将alpha值转换为东南西北方向
                let direction = this.getDirection(alpha);
                this.alpha = alpha
                // 显示设备的朝向
                // document.getElementById('direction').innerHTML = "手机的指向是: " + direction;
                console.log("手机的指向是: " + direction)
            });
        } else {
            console.log("你的浏览器不支持设备方向事件");
        }
        this.dom = document.getElementById("constel_canvas"); // 获取dom
        this.domWidth = this.dom.clientWidth;
        this.domHeight = this.dom.clientHeight;
        this.init();

        // 陀螺仪配置
        this.config_ = {
            fov: this.fov,// 相机fov,
            radius: this.universeRadius,// 半径
            width: this.domWidth,// 画布宽度
            height: this.domHeight,// 画布高度
            supportTouch: true,// 是否支持触摸
            supportOrient: true,// 是否支持陀螺仪
        };

        let offsetLongitude = 0; // 经度偏移量
        let offsetLatitude = 0; // 纬度偏移量
        // 白羊座
        // const offsetLongitude = 20.39616228280765;
        // const offsetLatitude = 25.507414080441674;

        // const queryConstelId = +this.routeQuery.constelId || await this.getConstelByLocation();
        const queryConstelId = +this.routeQuery.constelId
        const locationConstellId = await this.getConstelByLocation()

        if (
            Number.isInteger(queryConstelId) &&
            queryConstelId >= 1 &&
            queryConstelId <= 88
        ) {
            console.log("参数", queryConstelId);

            const constelCenter = this.constelTargetCoord[queryConstelId];
            if (constelCenter) {
                this.isDrag = false;
                this.orientation = false;

                const constelCenterCoord = constelCenter.labelPos;
                this.searchPhl = constelCenter.name;
                const targetCoordinate = this.calculateTargetCoord(
                    constelCenterCoord,
                    3000
                );

                const [x, y, z] = targetCoordinate;
                const xTemp = x / 5.6;
                const yTemp = y / 6.8;
                const zTemp = z / 7.2;
                const { lon, lat } = this.inverseCoordinate(xTemp, yTemp, zTemp);
                offsetLongitude = lon;
                offsetLatitude = lat;

                this.updateConstelIconLine({ nearestConstelId: queryConstelId }, 1);
            }
        } else if (locationConstellId) {
            console.log("定位", locationConstellId)
            const constelCenter = this.constelTargetCoord[locationConstellId];
            if (constelCenter) {
                this.orientation = true;

                const constelCenterCoord = constelCenter.labelPos;
                this.searchPhl = constelCenter.name;
                const targetCoordinate = this.calculateTargetCoord(
                    constelCenterCoord,
                    3000
                );

                const [x, y, z] = targetCoordinate;
                const xTemp = x / 5.6;
                const yTemp = y / 6.8;
                const zTemp = z / 7.2;
                const { lon, lat } = this.inverseCoordinate(xTemp, yTemp, zTemp);
                offsetLongitude = lon;
                offsetLatitude = lat;

                this.updateConstelIconLine({ nearestConstelId: locationConstellId }, 1);
            }
        } else {
            // 初始选中一个星座
            // this.onOrbitCtrlRotate();
            //开启陀螺仪
            this.orientation = true;
        }

        this.fix_ = {
            lat: offsetLatitude || 0,
            lon: offsetLongitude || 0,
            isFixed: offsetLatitude || offsetLongitude,
        };

        // 滑动和陀螺仪旋转
        this.touch_ = this.orient_ = {
            lat: 0,
            lon: 0,
        };

        this.onTouchOrientAnimate();
        this.initControl();

        if (utils.isWeiXin()) {
            this.setWeiXinShare();
        }

        window.addEventListener("resize", () => {
            location.reload();
        });
    },
    beforeDestroy() {
        // 销毁场景
        this.destroyScene();
    },
    methods: {
        getDirection(alpha) {
            if (alpha >= 0 && alpha < 45 || alpha >= 315 && alpha <= 360) {
                return "N";
            } else if (alpha >= 45 && alpha < 90) {
                return "NE";
            } else if (alpha >= 90 && alpha < 135) {
                return "E";
            } else if (alpha >= 135 && alpha < 180) {
                return "SE";
            } else if (alpha >= 180 && alpha < 225) {
                return "S";
            } else if (alpha >= 225 && alpha < 270) {
                return "SW";
            } else if (alpha >= 270 && alpha < 315) {
                return "W";
            } else {
                return "N";
            }
        },
        // 获取经纬度
        getUserLocation() {
            let location = {
            }
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        // // 成功获取位置后，更新经纬度
                        location = {
                            latitude: position.coords.latitude,
                            longitude: position.coords.longitude,
                        }
                    },
                    (error) => {
                        // 如果获取位置失败，显示错误信息
                        console.log(`位置获取失败: ${error.message}`)
                    }
                )
            } else {
                console.log('浏览器不支持定位功能')
            }

            return location
        },
        //获取经纬度下的星座
        async getConstelByLocation() {
            let id = 1;
            if (this.routeQuery.latitude && this.routeQuery.longitude) {
                this.location = {
                    latitude: this.routeQuery.latitude,
                    longitude: this.routeQuery.longitude,
                }
            } else {
                this.location = await this.getUserLocation()
            }

            // 获取当前时间和本地恒星时
            const now = new Date();
            const lst = this.getLocalSiderealTime(this.location.longitude, now);
            const currentMonth = now.getMonth() + 1;

            // 计算可见星座
            const visibleConstellations = [];
            const horizon = 90 - Math.abs(this.location.latitude); // 地平线以上可见区域

            constelsData.constels.forEach((item) => {
                // 转换赤经赤纬为十进制
                const [raStart, raEnd] = item.raRange.split('~').map(ra => this.convertRaToDecimal(ra));
                const [decStart, decEnd] = item.decRange.split('~').map(dec => this.convertDecToDecimal(dec));

                // 判断星座是否在地平线以上
                const isAboveHorizon = decEnd >= -horizon && decStart <= horizon;

                // 判断星座是否在当前本地恒星时可见
                const isInView = (lst >= raStart - 6 && lst <= raEnd + 6) ||
                    (lst + 24 >= raStart - 6 && lst + 24 <= raEnd + 6);

                // 判断是否在最佳观测月份
                const [bestStart, bestEnd] = item.bestObs.replace('月', '').split('-').map(Number);
                const isBestMonth = currentMonth >= bestStart && currentMonth <= bestEnd;

                if (isAboveHorizon && isInView && isBestMonth) {
                    visibleConstellations.push(item);
                }
            })
            console.log("lst", lst);

            console.log('最佳观看月份内星座范围内可见星座visibleConstellations', visibleConstellations);
            let visibleByMonth = [];
            visibleConstellations.forEach((item) => {
                let bestObs = item.bestObs.replace('月', '').split('-'); // 2023-05-01~2023-08-31
                if (currentMonth >= parseInt(bestObs[0]) && currentMonth <= parseInt(bestObs[1])) {
                    visibleByMonth.push(item);
                }
            })
            console.log('最佳观看月份内星座visibleByMonth', visibleByMonth);

            if (visibleByMonth.length === 0) {
                console.log('没有找到可见的星座');

                let minDistance = Infinity;
                let closestConstellation = null;

                visibleConstellations.forEach((item) => {
                    let bestObs = item.bestObs.replace('月', '').split('-');
                    let monthDiff = Math.abs(currentMonth - parseInt(bestObs[0])) > 3 ? Math.abs(currentMonth - parseInt(bestObs[1])) : Math.abs(currentMonth - parseInt(bestObs[0]));

                    if (monthDiff < minDistance) {
                        minDistance = monthDiff;
                        closestConstellation = item;
                    }
                });

                if (closestConstellation) {
                    visibleByMonth.push(closestConstellation);
                }
                console.log('可见月份内没有找到星座，找到距离最近的星座closestConstellation', visibleByMonth);

            }

            console.log('visibleByMonth', visibleByMonth);


            if (visibleByMonth.length > 0) {
                // 处理数组不为空的情况，随机选择一个元素
                // const randomIndex = Math.floor(Math.random() * visibleByMonth.length);
                // const currentid = visibleByMonth[randomIndex].id;
                // const name = visibleByMonth[randomIndex].name;
                // const bestObs = visibleByMonth[randomIndex].bestObs;
                // console.log('currentid %s name %s bestObs %s', currentid, name, bestObs);

                const currentid = this.calculateDistance(visibleByMonth);//计算夹角
                console.log('currentid', currentid);

                return Number(currentid);
            } else {
                // 处理数组为空的情况
                return 19
            }
        },
        //计算夹角
        calculateDistance(constels) {
            const cameraDirection = new THREE.Vector3();
            camera.getWorldDirection(cameraDirection); // 获取相机视线方向的单位向量
            console.log(camera.getWorldDirection(cameraDirection));
            let stars = [];
            constels.forEach((item) => {
                stars = stars.concat(item.starObjArr);
            })
            console.log('stars', stars);

            stars.forEach(star => {
                const starPosition = this.raDecToVector3(star.raDec[0], star.raDec[1]);
                const directionToStar = starPosition.clone().sub(camera.position).normalize();
                star.angleToCamera = cameraDirection.angleTo(directionToStar);
            });

            // 按夹角排序
            stars.sort((a, b) => a.angleToCamera - b.angleToCamera);
            const focusStar = stars[0]; // 获取夹角最小的星星
            console.log('夹角最小的星星', typeof focusStar.id);
            return focusStar.id.slice(0, 2);
        },
        //转换赤经赤纬到三维坐标
        raDecToVector3(raDeg, decDeg, radius = 100) {
            // 将赤纬转换为极角（phi），范围 [0, π]
            const phi = THREE.MathUtils.degToRad(90 - decDeg);
            // 将赤经转换为方位角（theta），调整方向以对齐 Three.js 坐标系
            const theta = THREE.MathUtils.degToRad(raDeg - 180);
            // 球面坐标转三维坐标
            return new THREE.Vector3().setFromSphericalCoords(radius, phi, theta);
        },
        latLonToVector3(latDeg, lonDeg, radius = 100) {
            // 纬度转换为极角（phi）
            const phi = THREE.MathUtils.degToRad(90 - latDeg);
            // 经度转换为方位角（theta），调整方向以对齐 Three.js 坐标系
            const theta = THREE.MathUtils.degToRad(lonDeg - 180);
            // 球面坐标转三维坐标
            return new THREE.Vector3().setFromSphericalCoords(radius, phi, theta);
        },
        //TODO
        //当前时间地点的赤经赤纬能看到赤经赤纬范围
        calculateVisibleRegion(lat, lon, date) {
            const siderealTime = this.calculateSiderealTime(date, lon);
            // 考虑视野范围，假设视野范围为 180°（简化模型）
            const raRange = 90;
            const visibleRAStart = (siderealTime - raRange + 360) % 360;
            const visibleRAEnd = (siderealTime + raRange) % 360;

            // 计算可见区域的赤纬范围
            const visibleDecMin = -(90 - lat);
            const visibleDecMax = 90 - lat;

            return {
                visibleRA: { start: visibleRAStart, end: visibleRAEnd },
                visibleDec: { min: visibleDecMin, max: visibleDecMax }
            };
        },
        calculateSiderealTime(date, longitude) {
            const JD = (date.getTime() / 86400000) + 2440587.5; // 儒略日
            const T = (JD - 2451545.0) / 36525.0;     // 儒略世纪数
            let ST = 280.46061837 + 360.98564736629 * (JD - 2451545.0) + 0.000387933 * T * T - T * T * T / 38710000.0;
            ST = (ST + longitude) % 360; // 修正为本地恒星时
            return ST;
        },
        //星座数据转换
        convertRaToDecimal(ra) {
            const [hours, minutes] = ra.split('h');
            const mins = minutes.replace('m', '');
            const raInDegrees = (parseInt(hours)) + (parseInt(mins) / 60);
            return raInDegrees;
        },

        convertDecToDecimal(dec) {
            return parseFloat(dec.replace('°', ''));
        },


        degToRad(deg) {
            return deg * Math.PI / 180;
        },
        // 计算两个点的球面角距离（单位为度）
        angularDistance(lat1, lon1, lat2, lon2) {
            // 将经纬度和赤经赤纬转化为弧度
            let lat1Rad = this.degToRad(lat1);
            let lon1Rad = this.degToRad(lon1);
            let lat2Rad = this.degToRad(lat2);
            let lon2Rad = this.degToRad(lon2);

            // 使用球面余弦定理
            let cosTheta = Math.sin(lat1Rad) * Math.sin(lat2Rad) + Math.cos(lat1Rad) * Math.cos(lat2Rad) * Math.cos(lon1Rad - lon2Rad);

            // 计算角度距离（弧度）
            let theta = Math.acos(cosTheta);

            // 将弧度转换为角度
            return theta * 180 / Math.PI;
        },
        latLonToXYZ(latitude, longitude, radius) {
            const lat = THREE.MathUtils.degToRad(latitude);  // 将纬度转换为弧度
            const lon = THREE.MathUtils.degToRad(longitude);  // 将经度转换为弧度

            const x = radius * Math.cos(lat) * Math.cos(lon);
            const y = radius * Math.cos(lat) * Math.sin(lon);
            const z = radius * Math.sin(lat);

            return new THREE.Vector3(x, y, z);  // 返回3D坐标
        },
        // 获取当前时间的本地恒星时
        getVisibleConstellations(latitude, longitude) {
            let constellations = constelsData.constels;
            let starsOrigin = [];
            constellations.forEach((constel) => {
                starsOrigin.push(...constel.starObjArr); // 修正属性名
            });

            // 计算本地恒星时
            const lst = this.getLocalSiderealTime(longitude, new Date());

            const visible = [];
            starsOrigin.forEach((item) => {
                const ra = item.raDec[0]; // 假设数据中的RA是度数，转为小时
                const dec = item.raDec[1];
                const hourAngle = lst - ra;

                // 计算高度角
                const latRad = latitude * Math.PI / 180;
                const decRad = dec * Math.PI / 180;
                const haRad = hourAngle * 15 * Math.PI / 180; // 时角转为弧度
                const sinAlt = Math.sin(decRad) * Math.sin(latRad) +
                    Math.cos(decRad) * Math.cos(latRad) * Math.cos(haRad);
                const altitude = Math.asin(sinAlt) * 180 / Math.PI;


                if (altitude > 0) {
                    visible.push(item);
                }
            });

            return visible;
        },
        // 计算儒略日
        getJulianDate(date) {
            let year = date.getFullYear();
            let month = date.getMonth() + 1;  // 月份从0开始，所以加1
            const day = date.getDate();
            const hours = date.getHours();
            const minutes = date.getMinutes();
            const seconds = date.getSeconds();

            if (month <= 2) {
                month += 12;
                year--;
            }

            // 儒略日计算公式
            const JD = 367 * year
                - Math.floor(7 * (year + Math.floor((month + 9) / 12)) / 4)
                + Math.floor(275 * month / 9)
                + day
                + 1721013.5 + (hours + minutes / 60 + seconds / 3600) / 24;

            console.log("JD", JD);
            return JD;
        },

        calculateGMST(jd) {
            const T = (jd - 2451545.0) / 36525.0;  // 儒略世纪数
            let GST = 18.697374558 + 24.06570982441908 * (jd - 2451545.0);  // 计算GST, 单位为小时
            GST = GST + (T * T) * 0.000026;  // 添加二次项修正
            GST = GST % 24;  // 转换到0-24小时范围
            if (GST < 0) GST += 24;  // 确保结果为正值
            console.log("GST", GST);
            return GST;
        },

        getLocalSiderealTime(longitude, date) {
            const JD = this.getJulianDate(date);  // 使用传入的date参数来计算儒略日
            const GST = this.calculateGMST(JD);   // 计算格林尼治恒星时
            let LST = GST + (longitude / 15);     // 经度对恒星时间的影响
            LST = LST % 24;  // 转换到0-24小时范围
            if (LST < 0) LST += 24;  // 确保结果为正值
            console.log("LST", LST);
            return LST;
        },
        getSiderealTime(date) {
            const jd = 367 * date.getUTCFullYear() - Math.floor((7 * (date.getUTCFullYear() + Math.floor((date.getUTCMonth() + 1) / 12))) / 4) + Math.floor((275 * date.getUTCMonth()) / 9) + date.getUTCDate() + 1721013.5 + (date.getUTCHours() / 24) + (date.getUTCMinutes() / 1440) + (date.getUTCSeconds() / 86400);

            const t = (jd - 2451545.0) / 36525;
            const theta = 280.46061837 + 360.98564736629 * (jd - 2451545.0) + t * t * (0.000387933 - t / 38710000);
            const siderealTime = (theta % 360 + 360) % 360;

            return siderealTime / 15; // Convert to hours
        },


        //计算星座是否可见
        // 计算儒略日 (JD)
        calculateJD(date) {
            const year = date.getUTCFullYear();
            const month = date.getUTCMonth() + 1;
            const day = date.getUTCDate();
            const hours = date.getUTCHours();
            const minutes = date.getUTCMinutes();
            const seconds = date.getUTCSeconds();

            const a = Math.floor((14 - month) / 12);
            const y = year + 4800 - a;
            const m = month + 12 * a - 3;

            let jd = day + Math.floor((153 * m + 2) / 5) + 365 * y + Math.floor(y / 4) - Math.floor(y / 100) + Math.floor(y / 400) - 32045;
            jd += (hours - 12) / 24 + minutes / 1440 + seconds / 86400;
            return jd;
        },

        // 计算格林尼治恒星时 (GST)
        calculateGST(date) {
            const jd = this.calculateJD(date);
            const T = (jd - 2451545.0) / 36525.0;
            // 计算 GST（单位为小时）
            let GST = 18.697374558 + 24.06570982441908 * (jd - 2451545.0);
            GST += 0.000387933 * T * T - T * T * T / 38710000.0;
            GST = GST % 24; // 将结果限制在 0-24 小时
            if (GST < 0) GST += 24; // 确保结果为正值
            return GST;
        },

        // 计算本地恒星时（LST，单位：小时）
        calculateLST(utcDate, longitude) {
            const GST = this.calculateGST(utcDate);
            console.log("GST:", GST);

            const longitude_hours = longitude / 15;  // 经度转为小时
            let LST = (GST + longitude_hours) % 24;
            return LST < 0 ? LST + 24 : LST;
        },

        // 计算时角（HA）
        calculateHA(LST, RA) {
            const LSTInDegrees = LST * 15;  // 将LST从小时转为度
            const RAInDegrees = RA * 15;  // 将赤经RA从小时转为度
            let HA = LSTInDegrees - RAInDegrees;  // 计算时角
            if (HA < 0) HA += 360;  // 时角必须是正数
            return HA;
        },

        // 计算天体的高度角
        calculateAltitude(HA, declination, latitude) {
            const HAInRadians = (HA * Math.PI) / 180;
            const declinationInRadians = (declination * Math.PI) / 180;
            const latitudeInRadians = (latitude * Math.PI) / 180;

            const altitude = Math.asin(Math.sin(declinationInRadians) * Math.sin(latitudeInRadians) + Math.cos(declinationInRadians) * Math.cos(latitudeInRadians) * Math.cos(HAInRadians));
            return (altitude * 180) / Math.PI;  // 转换回度
        },

        // 判断星座是否可见
        isConstellationVisible(utcDate, longitude, latitude, raRange, decRange) {
            longitude = Number(longitude);
            latitude = Number(latitude);
            // 解析赤经范围（RA）
            //   const [raStart, raEnd] = raRange.split('~').map(s => s.trim());
            //   const [raStartH, raStartM] = raStart.split('时').map(s => parseInt(s));
            //   const [raEndH, raEndM] = raEnd.split('时').map(s => parseInt(s));
            // 转换赤经为小时
            //   const RAStart = raStartH + raStartM / 60;
            //   const RAEnd = raEndH + raEndM / 60;
            const RAStart = raRange[0];
            const RAEnd = raRange[1];


            // 计算本地恒星时（LST）
            const LST = this.calculateLST(utcDate, longitude);
            console.log(LST);


            // 计算时角（HA）
            const HAStart = this.calculateHA(LST, RAStart);
            const HAEnd = this.calculateHA(LST, RAEnd);

            // 如果时角在指定范围内，计算高度角
            if (HAStart >= 0 && HAEnd <= 180) {
                const altitudeStart = this.calculateAltitude(HAStart, decRange[0], latitude);
                const altitudeEnd = this.calculateAltitude(HAEnd, decRange[1], latitude);
                return altitudeStart > 0 || altitudeEnd > 0;  // 如果有部分星座高度角大于0，则认为可见
            }

            return false;  // 如果星座不在视野范围内，则不可见
        },




        // 初始化场景
        init() {
            distanceObj = {};
            this.$nextTick(() => {
                this.bindDeviceOrientation();
            });
            setInterval(() => {
                this.allowOrientation = true;
            }, 100);

            const width = this.domWidth;
            const height = this.domHeight;

            scene = new THREE.Scene(); // 场景

            if (this.routeQuery.axes === "1") {
                // 红色X轴，绿色Y轴，蓝色Z轴。
                const axesHelper = new THREE.AxesHelper(800);
                axesHelper.name = "坐标轴";
                // 获取 AxesHelper 原点坐标
                const origin = axesHelper.position;
                scene.add(axesHelper);
            }

            // 相机的位置、朝向会影响到场景中物体的渲染效果，因此需要根据实际情况调整相机的位置、朝向。
            // 透视相机，视场、长宽比、近面、远面
            // 摄像机视锥体垂直视野角度，可见空间的垂直角度范围。从视图的底部到顶部，以角度来表示。默认值是50。
            // FOV越大，可见范围就越大，但场景中的物体看起来会更小。反之，如果FOV较小，则可见范围较小，但场景中的物体会看起来更大。
            // 摄像机视锥体长宽比
            // 摄像机视锥体近端面，默认值是0.1。表示相机的近裁剪面，在近裁剪面之前的物体会被裁剪掉。建议设置为正数并且越小越好。
            // 摄像机视锥体远端面，默认值是2000。表示相机的远裁剪面，在远裁剪面之外的物体会被裁剪掉。建议设置为正数并且越大越好。
            camera = new THREE.PerspectiveCamera(
                this.fov,// 视场 50
                this.domWidth / this.domHeight,// 长宽比
                0.1,// 近面
                this.farPlane// 远面 1000
            );
            // 使用了Controls控件后，OrbitControls覆盖了camera.lookAt，orbitControls.target来控制视点
            // 相机位置：Object3D的position属性的set方法
            this.cameraFov = this.fov;

            // 相机要设置在原点，星座图标是相对于这个点调的。
            //   camera.position.set(0, 30, -1); // 设置相机位置
            camera.position.copy(this.latLonToVector3(this.location.latitude, this.location.longitude));// 设置相机位置

            const cameraOrigin = camera.position;
            camera.up.set(0, 1, 0);  // 设置相机的上方向是Z轴正方向，
            this.cameraTarget = new THREE.Vector3(cameraOrigin.x, cameraOrigin.y, cameraOrigin.z + 1); // 设置相机目标点，默认为原点,默认为原点,如果不设置，默认是(0,0,0)
            camera.lookAt(this.cameraTarget);// 相机看向目标点
            //   camera.position.z = 30000;


            // 创建渲染器
            this.renderer = new THREE.WebGLRenderer({
                antialias: true, // 抗锯齿
                alpha: true, // 透明
            });


            // 调用绘制函数
            // this.createEquatorialLines();
            // this.createEquatorialScale();
            // color：默认白色，HEX（0x000000，0x换成#为另一种表示方式）、RGB、'skyblue'，三种格式
            this.renderer.setClearColor(0x000000, 0.1); // 设置场景透明度
            this.renderer.setPixelRatio(window.devicePixelRatio); // 开启HiDPI设置，解决模糊、纹理失真
            this.renderer.setSize(width, height); // 设置渲染区域尺寸
            this.dom.appendChild(this.renderer.domElement); // 将渲染器添加到dom中形成canvas


            this.createUniverse(); // 创建宇宙
            this.createLight(); // 创建光源
            this.createConstelsStar(); // 创建星星
            if (this.controlsEnable) {
                this.createOrbitControls(); // 创建鼠标控制器
            }


            this.createDirectionIndicators(scene, camera)
            // this.render(); // 渲染 修改交互，取消调用

            // 监听画布点击事件
            this.dom &&
                this.dom.addEventListener(
                    "click",
                    this.handleConstelCanvasClick,
                    false
                );
            // 画布双击事件
            this.dom &&
                this.dom.addEventListener(
                    "dblclick",
                    this.handleConstelCanvasDbclick,
                    false
                );

        },

        // 创建方向指示系统
        createDirectionIndicators(scene, camera) {
            // 修改方向坐标计算逻辑
            const radiusValue = this.universeRadius * 0.4;

            const cameraPos = camera.position.clone();

            // 获取相机前方向量（北方向）
            const direction = new THREE.Vector3();
            camera.getWorldDirection(direction);

            // 计算右方向（东）
            const right = new THREE.Vector3();
            right.crossVectors(camera.up, direction).normalize();

            this.directionCoords = [
                {
                    id: "north",
                    name: "北",
                    position: cameraPos.clone().add(direction.clone().multiplyScalar(radiusValue)),
                },
                {
                    id: "south",
                    name: "南",
                    position: cameraPos.clone().add(direction.clone().multiplyScalar(-radiusValue)),
                },
                {
                    id: "east",
                    name: "东",
                    position: cameraPos.clone().add(right.clone().multiplyScalar(radiusValue)),
                },
                {
                    id: "west",
                    name: "西",
                    position: cameraPos.clone().add(right.clone().multiplyScalar(-radiusValue)),
                },
            ];

            if (this.directionCoords.length > 0) {
                for (let j = 0; j < this.directionCoords.length; j++) {
                    const direction = this.directionCoords[j];
                    const { name, id, position } = direction;

                    this.createDirectionLabelSprite(position, name, id); // 创建方向文字
                    this.createDirectionIcon(direction); // 创建方向图标
                }
            }
        },
        // 销毁场景
        destroyScene() {
            cancelAnimationFrame(this.anId); // 根据动画id停止动画渲染
            cancelAnimationFrame(this._intFrame);
            this.renderer.dispose();
            // this.renderer.forceContextLoss(); // 强制失去上下文
            // scene.clear();
            // scene = null;
            // camera = null;
            // orbitControls = null;
            // this.dom.innerHTML = null;
            // this.renderer = null;
        },
        initControl() {
            const self = this;
            const config = this.config_;
            // 手势交互
            if (config.supportTouch) {

                let fov;
                this._toucher = new Toucher({
                    container: document.getElementById("constel_canvas"),
                    radius: config.radius,
                    onChange({ lon, lat, scale }) {

                        // let radius = 2000; // 设置相机与中心的距离
                        // let latRad = THREE.MathUtils.degToRad(lat); // 将纬度转换为弧度
                        // let lonRad = THREE.MathUtils.degToRad(lon); // 将经度转换为弧度

                        // let x = radius * Math.cos(latRad) * Math.cos(lonRad);
                        // let y = radius * Math.sin(latRad);
                        // let z = radius * Math.cos(latRad) * Math.sin(lonRad);

                        // camera.position.set(x, y, z);

                        // camera.lookAt(0, 0, 0);
                        // 缩放
                        if (scale) {
                            if (!self.orientation) {
                                // fov = config.fov / scale;
                                fov = self.config_.fov / scale;
                                // fov = Math.min(120, Math.max(fov, 60));
                                fov = Math.min(110, Math.max(fov, 60));
                                self.updateConfigData({ fov });
                                self.closeAllPopup(1);
                            }
                        }

                        // 拖拽、点击

                        if (lon !== undefined && lat !== undefined) {

                            self.toggleHeaderMenu("none");
                            self.toggleTopMenu("none");

                            // 超出范围，用fix来补

                            if (self.fix_.lat + self.orient_.lat + lat > 90) {
                                self.fix_.lat = 90 - self.orient_.lat - lat;
                            } else if (self.fix_.lat + self.orient_.lat + lat < -90) {
                                self.fix_.lat = -90 - self.orient_.lat - lat;
                            }
                            self.touch_ = { lon, lat };

                            self.closeAllPopup(2);
                        }
                    },
                });
            }

            // 陀螺仪交互
            if (config.supportOrient) {
                console.log(config);

                this.isDrag = true;
                this._orienter = new Orienter({
                    onChange({ lat, lon }) {
                        console.log({ lat, lon })
                        if (self.orientation) {
                            const { fix_ } = self;
                            if (!fix_.isFixed) {
                                self.fix_ = {
                                    lat: fix_.lat - lat,
                                    lon: fix_.lon - lon,
                                    isFixed: true,
                                };
                            }
                            if (Math.abs(self.orient_.lat - lat) >= 90) {
                                return;
                            }
                            // 超出范围，用fix来补
                            if (self.fix_.lat + self.touch_.lat + lat > 90) {
                                self.fix_.lat = 90 - self.touch_.lat - lat;
                            } else if (self.fix_.lat + self.touch_.lat + lat < -90) {
                                self.fix_.lat = -90 - self.touch_.lat - lat;
                            }

                            self.orient_ = { lat, lon };

                            self.closeAllPopup(3);
                        }
                    },
                });
            }
        },
        updateConfigData(config = {}) {
            this.config_ = Object.assign({}, this.config_, config);

            if (config.width || config.height) {
                this.renderer.setSize(this.config_.width, this.config_.height);
                camera.aspect = this.config_.width / this.config_.height;
            }
            if (config.fov) {
                camera.fov = config.fov;
                this.cameraFov = config.fov;
            }
            camera.updateProjectionMatrix();
            this.resizeLookAt();
        },
        pointToConstelById(id) {
            const constelCenter = this.constelTargetCoord[id];
            if (constelCenter) {
                const constelCenterCoord = constelCenter.labelPos;
                this.searchPhl = constelCenter.name;

                const targetCoordinate = this.calculateTargetCoord(
                    constelCenterCoord,
                    3000
                );
                if (this.controlsEnable) {
                    // 设置控制器的焦点，相机的新方向
                    orbitControls.target = new THREE.Vector3(...targetCoordinate);
                    orbitControls.update();
                } else {
                    this.cameraTarget = new THREE.Vector3(...targetCoordinate);
                    this.resizeLookAt();
                }

                this.updateConstelIconLine({ nearestConstelId: id }, 1);
            }
        },
        resizeLookAt() {
            camera.lookAt(this.cameraTarget);
            this.renderer.render(scene, camera);
        },
        // 创建所有星座的星星和星座名
        createConstelsStar() {
            if (this.constels.length > 0) {
                for (let index = 0; index < this.constels.length; index++) {
                    const constel = this.constels[index];
                    this.createStars(constel);
                    this.createConstelLabel(constel);
                }
            }
        },
        // 创建星座的星星
        createStars(constel, type) {
            let { name, id, coords, starObjArr } = constel;
            const positions = coords;
            // 星辰几何体
            const starsGeometry = new THREE.BufferGeometry();
            starsGeometry.setAttribute(
                "position",
                new THREE.Float32BufferAttribute(positions, 3)
            );
            let map = new THREE.TextureLoader().load(starBg);
            let color = "#7078D7";
            let size = this.initStarSize;
            if (type == "select") {
                size = size + 50;
                color = "#EAF8FF";
                map = new THREE.TextureLoader().load(starSelectedBg);
            }

            // 星辰材质，点材质
            const starsMaterial = new THREE.PointsMaterial({
                map: map, // 贴图纹理
                // color: color,
                size: size, // 星星的大小
                blending: THREE.AdditiveBlending, // 在使用此材质显示对象时要使用何种混合
                depthTest: false, // 是否在渲染材质时启用深度测试，不能与blending一起使用
                // depthWrite: false, //(深度写入)防止星辰在球体前面出现黑块
            });

            // 星辰的集合
            const starsMesh = new THREE.Points(starsGeometry, starsMaterial);
            starsMesh.name = `星集：${name}`;
            starsMesh.starId = id;
            if (type == "select") {
                starsMesh.selectPointId = id;
            }
            scene.add(starsMesh);

            this.starObjList.push(...starObjArr);

            let addStarName = false;
            if (addStarName) {
                // 添加星星名称
                for (let index = 0; index < starObjArr.length; index++) {
                    let starObj = starObjArr[index];
                    const loader = new FontLoader();
                    // 0607李亮提供的新字体ttf转为json格式
                    loader.load(
                        "/font/FZLanTingHeiS-DB-GB_Regular.json",
                        function (font) {
                            // 创建文本几何体
                            var textGeometry = new TextGeometry(starObj.name, {
                                // var textGeometry = new TextGeometry(index + '', {
                                font: font, // 字体名称
                                // size: 10, // 字号
                                // height: 2 // 文字高度
                                size: 1000, // 字号
                                height: 2, // 文字高度
                                // flipX: true
                                // flipY: true
                                // curveSegments: 12,
                                // bevelEnabled: false
                                // direction: "ltr"
                            });
                            // 创建材质
                            var textMaterial = new THREE.MeshBasicMaterial({
                                // color: 0xffffff // 颜色
                                color: "yellow", // 颜色
                            });
                            // 创建 mesh 对象
                            var textMesh = new THREE.Mesh(textGeometry, textMaterial);
                            // 设置位置
                            let [x, y, z] = starObj.position;
                            textMesh.position.set(x, y, z);
                            // textMesh.position.set(10, 10, 10);
                            textMesh.name = `星名：${starObj.name}`;
                            // 添加到场景中
                            scene.add(textMesh);
                            // this.renderer.render(scene, camera);
                        },
                        function (xhr) {
                            // console.log( (xhr.loaded / xhr.total * 100) + '% loaded' );
                        },
                        function (err) { }
                    );
                }
            }
        },
        // 创建星座图标
        createConstelIcon(constel) {
            let { name, id, icon, iconSize, iconPosition, starObjArr, color } =
                constel;

            const iconConfig = this.setIconConfig(id, color);
            color = iconConfig.color;
            const transparent = iconConfig.transparent;

            const width = iconSize.width || 5000;
            const height = iconSize.height || 5000;
            let iconPositionStar = starObjArr.find(
                (item) => item.name === iconPosition
            );
            if (!iconPositionStar) {
                iconPositionStar = starObjArr[Math.round(starObjArr.length / 2)];
            }
            const iconPos = iconPositionStar.position;
            // 平面几何，宽、高、分段数、分段数
            const geometry = new THREE.PlaneGeometry(width, height);
            // 平面几何体的法线垂直于它所处的平面，指向 Z 轴正方向，即平面几何体默认位于 XY 平面上。
            // 红绿面朝向蓝。
            // 基础网格材质
            const material = new THREE.MeshBasicMaterial({
                map: new THREE.TextureLoader().load(icon),
                // color: 0xffff00,
                // color: 'red',
                color: color,
                transparent: transparent, // 透明背景
                side: THREE.DoubleSide,
            });
            // 物体网格
            const plane = new THREE.Mesh(geometry, material);
            plane.lookAt(new THREE.Vector3(0, 0, 0));
            // Vector3设置x、y、z分量。
            // 位置点在几何的中心点
            plane.position.set(...iconPos);
            this.setConstelIconArgs(id, plane);

            plane.name = `图标：${name}`;
            plane.iconId = id;
            scene.add(plane);
        },
        // 设置星座图标，长宽、位移距离、旋转角度
        setConstelIconArgs(id, plane) {
            // 红色X轴，绿色Y轴，蓝色Z轴。
            // Object3D绕局部空间的X轴旋转这个物体，以弧度来表示，rotateX、Y、Z
            // 360°角=2π弧度，1弧度约为57.3°。π/2=1.57；2π/3=2.09；
            // 旋转是根据右手定则进行的。右手握住旋转轴，且大拇指指向正方向，其他四个手指指向旋转的正方向。
            // 顺时针旋转为正值，逆时针旋转为负值。
            // Object3D沿着某个轴平移distance个单位，translateX、Y、Z

            // 每次旋转都是基于原位置的空间轴旋转
            if (id == "1") {
                // 白羊座
                plane.translateY(400);
                plane.rotateX((Math.PI / 4) * 3);
                plane.rotateY(-0.5);
                plane.rotateZ(-0.6);
            } else if (id == "2") {
                // 金牛座
                plane.rotateX(Math.PI / 2);
                plane.rotateZ(0.5);
            } else if (id == "4") {
                // 巨蟹座
                plane.translateY(80);
                plane.translateZ(-300);
                plane.rotateY(-Math.PI / 2);
                plane.rotateX(-1);
                plane.rotateZ(2.1);
            } else if (id == "5") {
                // 狮子座
                plane.translateY(-800);
                plane.rotateY(-1.6 - Math.PI);
                plane.rotateZ(1.4);
            } else if (id == 6) {
                // 处女座
                plane.rotateY(Math.PI / 2);
            } else if (id == 7) {
                // 天秤座
                plane.translateX(900);
                plane.rotateX(-Math.PI / 2);
                plane.rotateZ(2.4);
            } else if (id == 9) {
                // 射手座
                plane.translateX(1000);
                plane.translateZ(-900);
                plane.rotateX(-Math.PI / 2);
                plane.rotateZ(Math.PI - 1.2);
            } else if (id == 10) {
                // 摩羯座
                plane.translateZ(-900);
                plane.rotateX(-Math.PI / 2);
                plane.rotateZ(Math.PI + 0.4);
                plane.rotateY(0.6);
            } else if (id == 16) {
                // 武仙座
                plane.translateY(-800);
                plane.rotateY(-Math.PI / 4);
                plane.rotateZ(Math.PI / 5);
                plane.rotateX(1);
            } else if (id == 20) {
                // 半人马座
                plane.rotateX(-Math.PI / 6);
                plane.rotateZ(1.2);
            } else if (id == 22) {
                // 牧夫座
                plane.translateX(-800);
                plane.rotateX(Math.PI / 2);
                plane.rotateZ(-1);
                plane.rotateY(-0.1);
            } else if (id == 23) {
                // 天鹅座
                plane.rotateX(-Math.PI / 2 - 1);
                plane.rotateZ(1.1);
            } else if (id == 26) {
                // 船尾座
                plane.translateY(800);
                plane.rotateX(Math.PI / 5);
                plane.rotateZ(0.4);
            } else if (id == 31) {
                // 仙后座
                plane.rotateY(Math.PI / 4);
            } else if (id == 32) {
                // 猎户座
                plane.rotateX(Math.PI / 2);
                plane.rotateZ(0.2);
            } else if (id == 37) {
                // 麒麟座
                plane.translateZ(-600);
                plane.rotateX(Math.PI / 2);
                plane.rotateZ(-0.6);
            } else if (id == 39) {
                // 凤凰座
                plane.translateY(-500);
                plane.translateX(100);
                plane.rotateY(-0.6);
                plane.rotateZ(0.6);
            } else if (id == 40) {
                // 猎犬座
                plane.rotateY(-0.6);
            } else if (id == 41) {
                // 天炉座
                plane.rotateY(-0.6);
                plane.rotateX(0.6);
            } else if (id == "42") {
                // 后发座
                plane.rotateY(-1);
                plane.translateY(1000);
                plane.translateX(-500);
            } else if (id == "43") {
                // 大犬座
                plane.rotateX(Math.PI / 3);
                plane.translateY(500);
                plane.translateX(-100);
            } else if (id == "48") {
                // 杜鹃座
                plane.rotateZ(0.6);
            } else if (id == "49") {
                // 印第安座
                plane.rotateZ(0.6);
            } else {
                const iconArgs = constelsIconArgs[id];
                if (iconArgs.length) {
                    for (let index = 0; index < iconArgs.length; index++) {
                        const arg = iconArgs[index];
                        const argName = arg.name;
                        const argValue = arg.value;
                        const argFun = plane[argName].bind(plane);
                        if (typeof argFun === "function" && argValue) {
                            argFun(argValue);
                        }
                    }
                }
            }
        },
        setIconConfig(id, colorParams) {
            let transparent = true;
            let color = "";
            if (colorParams === "blue") {
                transparent = false;
                color = colorParams;
            }
            return { transparent, color };
        },
        // 创建星座名称
        createConstelLabel(constel, type) {
            let {
                name,
                id,
                iconPosition,
                labelPositionIdx,
                starsOrigin,
                starObjArr,
            } = constel;

            let labelPos = starObjArr[labelPositionIdx].position;
            const ids = [
                3, 8, 11, 12, 13, 14, 15, 17, 18, 19, 21, 25, 27, 28, 29, 30, 33, 34,
                35, 36, 38, 45, 46, 47,
            ];
            if (ids.includes(+id) || id > 49) {
                labelPos = starObjArr.find(
                    (item) => item.name === iconPosition
                ).position;
            }
            this.constelTargetCoord[id] = { name, labelPos };

            let [ra, dec, dist] = starsOrigin[labelPositionIdx].position;
            if (ids.includes(+id) || id > 49) {
                [ra, dec, dist] = starsOrigin.find(
                    (item) => item.name === iconPosition
                ).position;
            }
            // 计算label的坐标，向原点靠近了一点
            dist = generalConst.dist - 4;
            const temp = [
                ra * generalConst.degree,
                dec,
                dist * generalConst.multiple,
            ];
            const { x, y, z } = utils.convertEquatorialToXYZ.apply(this, temp);

            this.createConstelLabelSprite([x, y, z], name, id, type);

            let oldAddFont = false;
            if (oldAddFont) {
                const loader = new FontLoader();
                loader.load(
                    "/font/FZLanTingHeiS-DB-GB_Regular.json",
                    function (font) {
                        // 创建文本几何体
                        var textGeometry = new TextGeometry(name, {
                            font: font, // 字体名称
                            // size: 10, // 字号
                            // height: 2 // 文字高度
                            size: 1000, // 字号
                            height: 2, // 文字高度
                            mirror: true,
                        });

                        // 创建材质
                        var textMaterial = new THREE.MeshBasicMaterial({
                            // color: 0xffffff // 颜色
                            color: "yellow", // 颜色
                        });
                        var textMesh = new THREE.Mesh(textGeometry, textMaterial);
                        // 创建一个 Group，并将 TextGeometry 添加到其中
                        const group = new THREE.Group();
                        group.add(textMesh);
                        // 对 Group 进行缩放，实现文字左右对称翻转
                        group.scale.x = -1;
                        let [x, y, z] = iconPos;
                        group.position.set(x, y, z);
                        group.name = `星座名：${name}`;
                        scene.add(group);
                    },
                    function (xhr) {
                        // console.log((xhr.loaded / xhr.total * 100) + '% loaded');
                    },
                    function (err) { }
                );
            }
        },
        createConstelLabelSprite(position, name, id, type) {
            const canvas = this.createConstelLabelCanvas(name, type);
            const texture = new THREE.CanvasTexture(canvas);

            texture.minFilter = THREE.LinearFilter;
            texture.wrapS = THREE.ClampToEdgeWrapping;
            texture.wrapT = THREE.ClampToEdgeWrapping;

            const labelMaterial = new THREE.SpriteMaterial({
                map: texture,
                transparent: true,
            });

            const label = new THREE.Sprite(labelMaterial);
            label.position.copy(position);
            if (type == "select") {
                label.scale.set(1000, 400, 1);
            } else {
                label.scale.set(800, 400, 1);
            }

            label.name = `label：${name}`;
            label.labelId = id;
            if (type == "select") {
                label.selectLabelId = id;
            }
            scene.add(label);

            let [x, y, z] = position;
            label.position.set(x, y, z);
        },
        // 创建星座名canvas
        createConstelLabelCanvas(name, type, id) {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            let ratio = this.getPixelRatio(ctx);
            if (ratio > 3) {
                ratio = 3;
            }
            let size = 12;
            let widthMultiple = ratio + 0;
            let heightMultiple = ratio + 0.1;
            let font = `${size}px`;
            if (type == "select") {
                size = 8;
                font = `${size}px`;
                widthMultiple = 0.6;
                heightMultiple = ratio + 1;
            }
            ctx.font = font;

            // measure how long the name will be
            let textWidth = ctx.measureText(name).width;
            if (type == "select") {
                textWidth = textWidth * 5;
            }
            const width = textWidth * widthMultiple;
            const height = size * heightMultiple; // height决定字体是否被垂直拉伸
            ctx.canvas.width = width;
            ctx.canvas.height = height;

            // need to set font again after resizing canvas
            ctx.font = font;
            ctx.textBaseline = "middle";
            ctx.textAlign = "center";

            ctx.fillStyle = "transparent";
            // ctx.fillStyle = 'blue';
            ctx.fillRect(0, 0, width, height);

            // scale to fit but don't stretch
            ctx.translate(width / 2, height / 2);
            ctx.scale(ratio, ratio);
            ctx.fillStyle = "rgba(255, 255, 255, 0.6)";
            if (type == "select") {
                ctx.fillStyle = "rgba(0, 218, 255, 1)";
            }
            if (id && this.isEnglish(id)) {
                ctx.fillStyle = "rgba(255, 255, 255, 1)";
            }
            ctx.fillText(name, 0, 0);

            return ctx.canvas;
        },
        getPixelRatio: function (context) {
            // canvas 适配比例
            var backingStore =
                context.backingStorePixelRatio ||
                context.webkitBackingStorePixelRatio ||
                context.mozBackingStorePixelRatio ||
                context.msBackingStorePixelRatio ||
                context.oBackingStorePixelRatio ||
                context.backingStorePixelRatio ||
                1;

            return (window.devicePixelRatio || 1) / backingStore;
        },
        // 创建星星之间连线
        addStarsLine(constel) {
            const { id, connRel, starObjArr } = constel;
            // 创建线条材质对象
            const material = new THREE.LineBasicMaterial({
                color: "#B3B6CF",
                linewidth: 0.5,
                // linecap: 'square', //ignored by WebGLRenderer
                // linejoin: 'round', //ignored by WebGLRenderer
            });

            for (let index = 0; index < connRel.length; index++) {
                const [startId, endId] = connRel[index];
                const startStar = starObjArr.find((item) => item.id == startId);
                const endStar = starObjArr.find((item) => item.id == endId);
                // 创建两个坐标点
                if (startStar && endStar) {
                    const startPoint = new THREE.Vector3(...startStar.position);
                    const endPoint = new THREE.Vector3(...endStar.position);
                    const geometry = new THREE.BufferGeometry().setFromPoints([
                        startPoint,
                        endPoint,
                    ]);
                    // 创建连接两个坐标点的线条对象
                    const line = new THREE.Line(geometry, material);
                    line.name = `${id}-${index}`;
                    line.lineId = `${id}-${index}`;
                    // 将线条对象添加到场景中
                    scene.add(line);
                }
            }
        },
        // 计算设备指向
        computeDevicePoint(alpha, beta, gamma) {
            console.log('alpha:', alpha, 'beta:', beta, 'gamma:', gamma);
            // 获取相机的前方向（北方向）

            // 将角度转换为弧度
            alpha = (alpha * Math.PI) / 180;
            beta = (beta * Math.PI) / 180;
            gamma = (gamma * Math.PI) / 180;

            // 计算设备空间指向
            const x = Math.sin(beta) * Math.cos(gamma);
            const y =
                -Math.sin(alpha) * Math.sin(beta) * Math.cos(gamma) +
                Math.cos(alpha) * Math.sin(gamma);
            const z =
                Math.cos(alpha) * Math.sin(beta) * Math.cos(gamma) +
                Math.sin(alpha) * Math.sin(gamma);
            return {
                x,
                y,
                z,
            };
        },
        throttle(fn, wait) {
            let timer = null;
            return function () {
                if (timer) {
                    return;
                }
                timer = setTimeout(() => {
                    fn.apply(this, arguments);
                    timer = null;
                }, wait);
            };
        },

        // 创建宇宙，球形宇宙
        createUniverse() {
            // 球体，半径（要小于相机的远面，否则无法展示）、水平分段数、垂直分段数
            let universeGeometry = new THREE.SphereGeometry(
                this.universeRadius,
                100,
                100
            );
            // 此半径的宇宙，看不到初始三星座的图标和连线
            // let universeGeometry = new THREE.SphereGeometry(100, 100, 100);

            let universeMaterial = new THREE.MeshLambertMaterial({
                map: new THREE.TextureLoader().load(universeBg), // 贴图纹理
                // side: THREE.DoubleSide //双面显示
                side: THREE.BackSide,
            });
            //宇宙网格
            let universeMesh = new THREE.Mesh(universeGeometry, universeMaterial);
            universeMesh.name = "宇宙";
            scene.add(universeMesh);

            // 添加赤道和黄道
            // this.addCelestialCircles();
            // // 添加天球网格系统
            // this.addCelestialGrid();
        },
        // 新增方法：添加天球参考圈
        addCelestialCircles() {
            const radius = this.universeRadius;
            const segments = 64; // 圆环分段数

            // 创建赤道（蓝色）
            const equator = this.createCelestialCircle(
                radius,
                new THREE.Vector3(0, 0, 0), // 赤道平面（XZ平面）
                0x0000ff
            );
            equator.name = "赤道";
            scene.add(equator);

            // 创建黄道（黄色，倾斜23.5度）
            const ecliptic = this.createCelestialCircle(
                radius,
                new THREE.Vector3(THREE.MathUtils.degToRad(23.439281), 0, 0), // 绕X轴旋转
                0xffff00
            );
            ecliptic.name = "黄道";
            scene.add(ecliptic);
        },

        // 修改后的 createCelestialCircle 方法
        createCelestialCircle(radius, rotation, color) {
            // 使用环形几何体（内外半径差形成线宽）
            const geometry = new THREE.RingGeometry(
                radius * 0.999, // 内半径（稍小于外半径）
                radius,         // 外半径
                64             // 分段数
            );

            // 创建线材质
            const material = new THREE.LineBasicMaterial({
                color: color,
                linewidth: 1,
                transparent: true,
                opacity: 0.8
            });

            // 创建环形线（自动闭合）
            const circle = new THREE.LineLoop(
                geometry,
                material
            );

            // 调整平面方向
            circle.rotation.set(rotation.x, rotation.y, rotation.z);

            return circle;
        },
        // 新增方法：创建天球网格系统
        addCelestialGrid() {
            const radius = this.universeRadius;

            // 创建容器组
            const celestialGrid = new THREE.Group();
            celestialGrid.name = "CelestialGrid";

            // 添加赤纬线（纬度圈）
            this.addDeclinationLines(celestialGrid, radius);

            // 添加赤经线（经度弧）
            this.addRightAscensionLines(celestialGrid, radius);

            scene.add(celestialGrid);

            // 添加刻度系统
            this.addGridTicks(celestialGrid, radius);
        },

        // 辅助方法：生成赤纬线（平行圈）
        addDeclinationLines(group, radius) {
            const declinationGroup = new THREE.Group();
            declinationGroup.name = "DeclinationLines";

            // 参数配置
            const angleStep = 15; // 纬度间隔（度）
            const segments = 64;  // 圆环分段数
            const maxLat = 85;    // 最大显示纬度（避免极区过密）

            for (let lat = -maxLat; lat <= maxLat; lat += angleStep) {
                // 计算当前纬度的圆半径
                const circleRadius = radius * Math.cos(THREE.MathUtils.degToRad(lat));

                // 创建环形几何体
                const geometry = new THREE.RingGeometry(
                    circleRadius * 0.999,
                    circleRadius,
                    segments
                );

                // 创建线材质
                const material = new THREE.LineBasicMaterial({
                    color: 0x00ffff,
                    transparent: true,
                    opacity: 0.3
                });

                // 生成线环并旋转到赤纬平面
                const line = new THREE.LineLoop(geometry, material);
                line.rotation.x = Math.PI / 2; // 将圆环旋转到水平面
                line.position.y = radius * Math.sin(THREE.MathUtils.degToRad(lat));

                declinationGroup.add(line);
            }

            group.add(declinationGroup);
        },

        // 辅助方法：生成赤经线（子午弧）
        addRightAscensionLines(group, radius) {
            const rightAscensionGroup = new THREE.Group();
            rightAscensionGroup.name = "RightAscensionLines";

            // 参数配置
            const angleStep = 30; // 经度间隔（度）
            const segments = 64;  // 弧线分段数

            for (let lon = 0; lon < 360; lon += angleStep) {
                // 生成半圆顶点数组
                const points = [];
                for (let i = 0; i <= segments; i++) {
                    const theta = (i / segments) * Math.PI; // 0到π（半圆）
                    const x = radius * Math.sin(theta) * Math.cos(THREE.MathUtils.degToRad(lon));
                    const z = radius * Math.sin(theta) * Math.sin(THREE.MathUtils.degToRad(lon));
                    const y = radius * Math.cos(theta);
                    points.push(new THREE.Vector3(x, y, z));
                }

                // 创建线几何体
                const geometry = new THREE.BufferGeometry().setFromPoints(points);

                // 创建线材质
                const material = new THREE.LineBasicMaterial({
                    color: 0x00ffff,
                    transparent: true,
                    opacity: 0.3
                });

                // 生成线对象
                const line = new THREE.Line(geometry, material);
                rightAscensionGroup.add(line);
            }

            group.add(rightAscensionGroup);
        },
        // 新增方法：添加刻度系统
        addGridTicks(group, radius) {
            // 主刻度间隔（赤纬15°/赤经1小时）
            this.addMainTicks(group, radius, 15, 15);

            // 次刻度间隔（赤纬5°/赤经5分钟）
            this.addSubTicks(group, radius, 5, 5);
        },

        // 辅助方法：生成主刻度
        addMainTicks(group, radius, decStep, raStep) {
            const tickGroup = new THREE.Group();
            tickGroup.name = "MainTicks";

            // 赤纬主刻度
            for (let dec = -90; dec <= 90; dec += decStep) {
                if (dec === 0) continue; // 跳过赤道（已有线条）
                const circleRadius = radius * Math.cos(THREE.MathUtils.degToRad(dec));
                const angleStep = 360 / (24 * 4); // 1小时对应15°

                for (let angle = 0; angle < 360; angle += angleStep) {
                    const pos = this.getSpherePoint(radius, dec, angle);
                    // this.createTick(tickGroup, pos, 0.02, 0x00ff00, dec + "°");
                }
            }

            // 赤经主刻度（小时标签）
            for (let ra = 0; ra < 360; ra += raStep) {
                const labelStep = 30; // 每30°一个标签（对应2小时）
                for (let dec = -80; dec <= 80; dec += 10) {
                    const pos = this.getSpherePoint(radius, dec, ra);
                    if (ra % labelStep === 0) {
                        this.createLabel(tickGroup, pos, ra / 15 + "h");
                    }
                }
            }

            group.add(tickGroup);
        },
        createLabel(parent, position, text) {
            // 使用TextGeometry生成3D文字
            console.log(text);

            const loader = new FontLoader();
            loader.load("/font/FZLanTingHeiS-DB-GB_Regular.json", font => {
                const textGeo = new TextGeometry(text, {
                    font: font,
                    size: 0.1,
                    height: 0.01
                });
                const textMat = new THREE.MeshBasicMaterial({ color: 0xffffff });
                const textMesh = new THREE.Mesh(textGeo, textMat);

                // 调整标签位置和方向
                textMesh.position.copy(position);
                textMesh.lookAt(camera.position); // 始终面向相机

                parent.add(textMesh);
            })
        },
        // 辅助方法：生成次刻度
        addSubTicks(group, radius, decStep, raStep) {
            const subTickGroup = new THREE.Group();
            subTickGroup.name = "SubTicks";

            // 赤纬次刻度
            for (let dec = -90; dec <= 90; dec += decStep) {
                const circleRadius = radius * Math.cos(THREE.MathUtils.degToRad(dec));
                const angleStep = 360 / (24 * 12); // 5分钟间隔

                for (let angle = 0; angle < 360; angle += angleStep) {
                    const pos = this.getSpherePoint(radius, dec, angle);
                    this.createTick(subTickGroup, pos, 0.01, 0x0088ff);
                }
            }

            group.add(subTickGroup);
        },

        // 工具方法：创建单个刻度
        createTick(group, position, size, color, text) {
            // 刻度几何体
            const geometry = new THREE.BoxGeometry(size, size, size * 3);
            const material = new THREE.MeshBasicMaterial({ color: color });
            const tick = new THREE.Mesh(geometry, material);

            // 对齐表面
            tick.lookAt(new THREE.Vector3(0, 0, 0));
            tick.position.copy(position);

            // 添加文字标签
            if (text) this.createTextLabel(tick, text);

            group.add(tick);
        },

        // 工具方法：创建3D文字
        createTextLabel(parent, text) {
            const loader = new FontLoader();
            loader.load("/font/FZLanTingHeiS-DB-GB_Regular.json", font => {
                const textGeo = new TextGeometry(text, {
                    font: font,
                    size: 0.1,
                    height: 0.01
                });

                const textMat = new THREE.MeshBasicMaterial({ color: 0xffffff });
                const textMesh = new THREE.Mesh(textGeo, textMat);

                // 调整文字位置
                textMesh.position.copy(parent.position);
                textMesh.scale.multiplyScalar(1.01); // 略微外扩
                textMesh.lookAt(camera.position); // 始终面向相机

                parent.add(textMesh);
            });
        },

        // 工具方法：球坐标转笛卡尔坐标
        getSpherePoint(radius, dec, ra) {
            const phi = THREE.MathUtils.degToRad(90 - dec);
            const theta = THREE.MathUtils.degToRad(ra);

            return new THREE.Vector3(
                radius * Math.sin(phi) * Math.cos(theta),
                radius * Math.cos(phi),
                radius * Math.sin(phi) * Math.sin(theta)
            );
        },
        // 创建光源，环境光
        createLight() {
            let ambient = new THREE.AmbientLight(new THREE.Color(0xffffff)); // 环境光，没有方向，不能用来投射阴影
            ambient.name = "环境光源";
            scene.add(ambient);

            const pointLight = new THREE.PointLight(
                new THREE.Color(0xffffff),
                2,
                1,
                0
            ); // 点光源
            pointLight.visible = true;
            pointLight.position.set(0, 0, 0); //点光源在原点充当太阳
            pointLight.name = "点光源";
            // scene.add(pointLight); //点光源添加到场景中
        },
        // 创建鼠标控件，轨道控制器。可以使相机围绕目标进行轨道运动。
        createOrbitControls() {
            // 被控制的相机，用于事件监听的HTML元素。
            orbitControls = new OrbitControls(camera, this.renderer.domElement);

            orbitControls.enablePan = false; // 右键（双指）平移拖拽摄像机

            // 禁止水平滑动-start
            // orbitControls.minAzimuthAngle = Math.PI;   // 最小水平旋转角度（弧度）
            // orbitControls.maxAzimuthAngle = Math.PI;   // 最大水平旋转角度（弧度）
            // 禁止水平滑动-end

            // 禁止竖向滑动-start
            // orbitControls.maxPolarAngle = Math.PI / 2; // 最大仰角限制为90度，禁止向上旋转
            // orbitControls.minPolarAngle = Math.PI / 2; // 最小仰角限制为0度，禁止向下旋转
            // 禁止竖向滑动-end

            orbitControls.enableZoom = true; // 摄像机缩放
            orbitControls.zoomSpeed = 1; // 摄像机缩放的速度，其默认值为1。
            // minDistance、maxDistance可限制相机缩放的等级
            orbitControls.minDistance = this.controlsMinDistance; // 你能够将相机向内移动多少（仅适用于PerspectiveCamera），其默认值为0。相机距离目标最小距离
            // maxDistance太大时，缩小会超出宇宙，宇宙球外面是白色的。
            orbitControls.maxDistance = this.controlsMaxDistance; // 你能够将相机向外移动多少（仅适用于PerspectiveCamera），其默认值为Infinity。相机距离目标最大距离

            orbitControls.enableDamping = true; // 启用阻尼（惯性）/滑动阻尼
            orbitControls.dampingFactor = 0.05; // 阻尼惯性的大小，默认0.05；生效，必须在动画循环里调用update。值越小，脱手后滑动的距离越远。

            // orbitControls.autoRotate = true; // 以自动围绕目标旋转，自转(相机)

            // 如果您发现宇宙的旋转速度大于拖拽速度，这可能是因为您的场景过于庞大，导致 OrbitControls 无法正确处理缩放和旋转的速度。
            // 将这些参数设置为更小的值，可以减缓宇宙的旋转速度，使其更接近于拖拽速度：
            // rotateSpeed与宇宙半径、相机远面配合设置，才能解决宇宙旋转过快问题。
            orbitControls.rotateSpeed = this.rotateSpeed; // 旋转速度，默认值为1。
            // orbitControls.panSpeed = 0.2; // 平移速度，默认值为1。
            // orbitControls.enabled = false; // 禁用 OrbitControls 的焦点控制

            // target控制器的焦点，object（正被控制的摄像机）的轨道围绕它运行。
            const target = new THREE.Vector3(...this.initTarget);
            orbitControls.target = target;
            orbitControls.update();
            // 初始化时的缩放距离
            this.lastZoom = orbitControls.target.distanceTo(
                orbitControls.object.position
            );

            this.bindOrbitCtrlEvent();
        },
        // orbitControls绑定事件
        bindOrbitCtrlEvent() {
            const that = this;
            let isInteracting = false;
            // 当相机或目标位置发生变化时触发此事件
            orbitControls.addEventListener("start", function (event) {
                this.isDrag = true;
                isInteracting = true;
            });

            // 控制器有惯性，会多次调用
            // 当用户开始进行交互操作（例如鼠标按下或触摸开始）时触发此事件。
            orbitControls.addEventListener("change", function () {
                this.isDrag = true;
                // isInteracting为true主动交互操作状态，false为惯性运动状态
                if (isInteracting) {
                    var zoomDistance = orbitControls.target.distanceTo(
                        orbitControls.object.position
                    );
                    if (
                        that.lastZoom !== null &&
                        Math.abs(zoomDistance - that.lastZoom) > 5
                    ) {
                        // 用户进行了缩放操作，暂无交互
                        if (zoomDistance - that.lastZoom > 0) {
                            // 缩小
                        } else {
                            // 放大
                        }
                    } else {
                        // 用户进行了旋转（滑动）操作
                        this.isDrag = true;

                        that.onOrbitCtrlRotate();
                    }
                    that.lastZoom = zoomDistance;
                }
            });

            // 当用户结束交互操作（鼠标释放或触摸结束）时触发此事件。
            orbitControls.addEventListener("end", function () {
                isInteracting = false;
            });
        },
        closeAllPopup(type) {
            this.showConstelInfoPopup = false;
            this.toggleHeaderMenu("none");
            // this.toggleTopMenu('none');

            // 重置选中星座数据
            this.clickedConstel = {
                name: "",
                starsOrigin: [],
                id: "",
            };
        },
        // 相机或控制器旋转、滑动事件
        onOrbitCtrlRotate() {
            // this.showConstelInfoPopup = false;
            // this.toggleHeaderMenu('none');
            // this.toggleTopMenu('none');

            // 检测是否在视口范围内、清除（删除）旧的、添加（保存）新的
            const that = this;
            const thrtlFun = this.throttle(() => {
                // 旋转时用户进行了点击操作，响应点击操作，不查找屏幕中心的星座。
                if (!that.clickedConstel.id) {
                    const inScreenRange = that.frustumRangedetect();
                    if (inScreenRange.length > 0) {
                        const nearestPoint = that.findNearestPoint(inScreenRange);
                        this.updateConstelIconLine(nearestPoint, 2);
                    }
                }
            }, 400);
            thrtlFun();
        },
        // 渲染
        render() {
            this.onTouchOrientAnimate();

            // 请求动画帧，屏幕每刷新一次调用一次，绑定屏幕刷新频率
            this.anId = requestAnimationFrame(this.render); //记录下动画id可用于销毁场景

            if (this.controlsEnable) {
                orbitControls.update(); // 鼠标控件实时更新
            }

            // 渲染场景
            this.renderer.render(scene, camera);
        },
        // 处理手势和陀螺仪事件
        onTouchOrientAnimate() {
            this.isDrag = true;
            const config = this.config_;
            let lat = this.touch_.lat + this.fix_.lat + this.orient_.lat;
            let lon = this.touch_.lon + this.fix_.lon + this.orient_.lon;

            // 外部传的经纬度
            // let obj = config.onFrame(lon, lat)||{};
            // lon += (obj.lon || 0);
            // lat += (obj.lat || 0);

            lat = Math.max(-89, Math.min(89, lat));

            lat = this.degToRad(lat);
            lon = this.degToRad(lon);

            let multiple = 500;
            const x = multiple * Math.cos(lat) * Math.cos(lon);
            const y = multiple * Math.sin(lat);
            const z = multiple * Math.cos(lat) * Math.sin(lon);
            const target = new THREE.Vector3(x, y, z);
            if (this.controlsEnable) {
                orbitControls.target = target;
            } else {
                this.cameraTarget.x = x;
                this.cameraTarget.y = y;
                this.cameraTarget.z = z;
            }

            // const queryConstelId = +this.routeQuery.constelId;
            // if (this.unOperated && Number.isInteger(queryConstelId) && (queryConstelId >= 1 && queryConstelId <= 88)) {
            //   this.pointToConstelById(queryConstelId);
            // } else {
            //   // 初始选中一个星座
            //   this.onOrbitCtrlRotate();
            // }
            this.onOrbitCtrlRotate();

            this.resizeLookAt();

            this._intFrame = requestAnimationFrame(
                this.onTouchOrientAnimate.bind(this)
            );
        },
        // 星空点击事件
        handleConstelCanvasClick(e) {
            if (this.isAppH5) {
                return
            }

            if (this.orientation) {
                return;
            }

            const dom = document.getElementById("constel_canvas");
            const width = dom.clientWidth; // 窗口宽度
            const height = dom.clientHeight; // 窗口高度
            // 将鼠标点击位置的屏幕坐标转换成threejs中的标准坐标
            this.mouse.x = (e.offsetX / width) * 2 - 1;
            this.mouse.y = -(e.offsetY / height) * 2 + 1;
            // 通过鼠标点的位置和当前相机的矩阵计算出raycaster
            this.raycaster.setFromCamera(this.mouse, camera);

            // 生成星座图标、星星、星名 网格列表
            let starsMeshList = [];
            scene.children.forEach((p) => {
                if (p.name !== "") {
                    starsMeshList.push(p);
                }
            });

            // 获取raycaster直线和网格列表相交的集合
            let intersects = this.raycaster.intersectObjects(starsMeshList);
            // 判断是否点击到虚无的太空
            if (intersects.length == 0) {
                return;
            }

            const clickedContent = intersects[0].object;
            const type = clickedContent.type;
            let id = "";

            if (type === "Sprite") {
                id = clickedContent.labelId;
            }
            if (id  && this.routeQuery.click == 'true') {
                const clickedConstel = this.constels.find((item) => item.id === id);
                this.clickedConstel = clickedConstel;
                // 绘制图标、连线
                this.updateConstelIconLine({ nearestConstelId: id }, 3);
                this.showConstelInfoPopup = true;
            }
        },
        // 双击事件
        handleConstelCanvasDbclick(e) {
            if (this.isAppH5 || this.routeQuery.partner == '9797491d04306f55d53aafa68a7a63ac') {
                return
            }
            if (this.orientation) {
                this.orientation = false;
                if (this.addedConstel[0].id && this.routeQuery.click == 'true') {
                    this.clickedConstel = this.addedConstel[0];
                    this.showConstelInfoPopup = true;
                }
            } else {
                this.orientation = true;
                if (this.showConstelInfoPopup) {
                    this.showConstelInfoPopup = false;
                }
            }
        },
        // 计算在线上距原点dist的点的坐标
        calculateTargetCoord([x1, y1, z1], dist = 6) {
            const distance = dist;
            const sqrtSum = Math.sqrt(x1 * x1 + y1 * y1 + z1 * z1);
            const x2 = (x1 * distance) / sqrtSum;
            const y2 = (y1 * distance) / sqrtSum;
            const z2 = (z1 * distance) / sqrtSum;
            return [x2, y2, z2];
        },
        // 视锥体检测+屏幕空间检测
        frustumRangedetect() {
            const points = this.starObjList;
            // 在这里进行 frustum 相关的计算
            const frustum = new THREE.Frustum();
            const matrix = new THREE.Matrix4();
            camera.updateMatrixWorld();
            matrix.multiplyMatrices(
                camera.projectionMatrix,
                camera.matrixWorldInverse
            );
            frustum.setFromProjectionMatrix(matrix);

            // 检测点是否进出屏幕范围
            const width = window.innerWidth; // 屏幕宽度
            const height = window.innerHeight; // 屏幕高度
            const inScreenRange = [];

            // 遍历需要监控的点，并判断它们是否在视锥体内
            for (let i = 0; i < points.length; i++) {
                const star = points[i];
                const point = new THREE.Vector3(...star.position);
                if (frustum.containsPoint(point)) {
                    point.project(camera); // 将点的位置向量投影到屏幕空间

                    var x = ((point.x + 1) * width) / 2; // 计算点在视口中的x坐标
                    var y = ((-point.y + 1) * height) / 2; // 计算点在视口中的y坐标

                    // 点在视口内
                    if (x > 0 && x < width && y > 0 && y < height) {
                        inScreenRange.push({
                            ...star,
                            x,
                            y,
                        });
                    }
                }
            }

            return inScreenRange;
        },
        // 屏幕空间检测，屏幕空间是指3D场景在2D屏幕上的投影
        screenSpaceRangeDetect() {
            const stars = this.starObjList;
            // 检测点是否进出屏幕范围
            var width = window.innerWidth; // 屏幕宽度
            var height = window.innerHeight; // 屏幕高度
            const inScreenRange = [];

            for (let i = 0; i < stars.length; i++) {
                const star = stars[i];
                var vector = new THREE.Vector3(...star.position); // 点的3D位置向量
                vector.project(camera); // 将点的位置向量投影到屏幕空间

                var x = ((vector.x + 1) * width) / 2; // 计算点在视口中的x坐标
                var y = ((-vector.y + 1) * height) / 2; // 计算点在视口中的y坐标

                // 点在视口内
                if (x > 0 && x < width && y > 0 && y < height) {
                    inScreenRange.push({
                        ...star,
                        x,
                        y,
                    });
                }
            }

            return inScreenRange;
        },
        calculatePointDis(x2, y2) {
            const width = window.innerWidth;
            const height = window.innerHeight;
            var centerX = width / 2;
            var centerY = height / 2;
            const dx = x2 - centerX;
            const dy = y2 - centerY;
            return Math.sqrt(dx * dx + dy * dy);
        },
        findNearestPoint(points) {
            let nearestIdx = 0;
            let nearestDis = 0;
            let nearestPoint = {};
            if (points.length > 0) {
                let distance = 0;
                for (let index = 0; index < points.length; index++) {
                    const point = points[index];
                    distance = this.calculatePointDis(point.x, point.y);
                    if (index === 0) {
                        nearestDis = distance;
                        nearestPoint = point;
                    } else if (distance < nearestDis) {
                        nearestIdx = index;
                        nearestDis = distance;
                        nearestPoint = point;
                    }
                }
            }
            return {
                nearestIdx,
                nearestPoint,
                nearestConstelId: nearestPoint.id.slice(0, -2),
            };
        },
        updateConstelIconLine({ nearestConstelId }, type) {
            const constel = this.constels.find((item) => item.id == nearestConstelId);
            const haveAdded = this.addedConstel.find(
                (item) => item.id == nearestConstelId
            );
            if (!haveAdded) {
                // 删除旧的
                const oldConstel = this.addedConstel[0];
                if (oldConstel) {
                    this.deleteConstelIconLine(oldConstel.id);
                    // 原选中的，1删除选中文字图标，2添加默认文字图标（逻辑以上方法有）
                    this.addedConstel.splice(0, 1);
                }
                // 添加新的
                this.createConstelIcon(constel);
                this.addStarsLine(constel);
                this.addedConstel.push(constel);

                // 新选中的，1删除默认状态的星座名，2添加选中状态的星座名
                let selectMesh = scene.children.find((item) => {
                    if (item.type === "Sprite") {
                        if (item.labelId == nearestConstelId && !item.selectLabelId) {
                            return item;
                        }
                    }
                });
                if (selectMesh) {
                    scene.remove(selectMesh);
                    selectMesh.material.dispose();
                    selectMesh.geometry.dispose();
                    selectMesh.material = null;
                    selectMesh.geometry = null;
                    selectMesh = null;
                }
                this.createConstelLabel(constel, "select");
                // 添加选中状态的星星
                this.createStars(constel, "select");
            }
        },
        // 删除星座图标和连接线
        deleteConstelIconLine(constelId) {
            const meshes = scene.children;
            for (let index = 0; index < meshes.length; index++) {
                let mesh = meshes[index];
                let type = mesh.type;
                let id = "";
                // 删除（下面remove）选中状态的图标
                if (type === "Mesh") {
                    id = mesh.iconId;
                }
                // 删除（下面remove）选中状态的连线
                if (type === "Line") {
                    id = mesh.lineId;
                }
                if (type === "Sprite") {
                    id = mesh.selectLabelId;
                    if (id) {
                        // 已经删除（下面remove）了选中状态的星座名，添加默认状态的星座名
                        const constel = this.constels.find((item) => item.id == id);
                        this.createConstelLabel(constel);
                    }
                }
                // 删除（下面remove）选中状态的星星
                if (type === "Points") {
                    id = mesh.selectPointId;
                }

                if (id && id.indexOf(constelId) === 0) {
                    scene.remove(mesh);
                    index--; // 数组内容少了一个，向前移动
                    mesh.material.dispose();
                    mesh.geometry.dispose();
                    mesh.material = null;
                    mesh.geometry = null;
                    mesh = null;
                }
            }
        },
        handleViewMoreInfoClick() {
            const clickedConstel = this.clickedConstel;
            const id = clickedConstel.id;
            if (id) {
                this.$router.push({
                    path: "/constelDetails",
                    query: {
                        id,
                    },
                });
            }
        },
        handleCloseConstelClick() {
            this.onCloseConstelInfoPopup();
        },
        onCloseConstelInfoPopup() {
            this.showConstelInfoPopup = false;

            // 重置选中星座数据
            this.clickedConstel = {
                name: "",
                starsOrigin: [],
                id: "",
            };
        },
        handleScreenClick() {
            let url = window.location.href;
            if (url.includes("?")) {
                url = url + "&fullScreen=true";
            } else {
                url = url + "?fullScreen=true";
            }
            // console.log('handleScreenClick :>> ', url);
            // window.location.replace(url);
            window.location.href = url;
            // window.location.href = 'https://h5.zuimeitianqi.com/pag e/zh/today.html?cityId=01012507&fullScreen=true';
        },
        handleOutputClick() {
            // let url = window.location.href;
            // console.log('%c JsInterface', "color: purple;", typeof JsInterface);
            // if (typeof JsInterface !== 'undefined') {
            //   console.log('%c JsInterface', "color: purple;", JsInterface);
            // }
            // console.log('%c goBack', "color: purple;", typeof goBack);
            // if (typeof goBack !== 'undefined') {
            //   // goBack();
            // }

            // console.log('%c getStatusHeight', "color: purple;", typeof getStatusHeight);
            // if (typeof getStatusHeight !== 'undefined') {
            //   const status = getStatusHeight();
            //   console.log('%c status', "color: purple;", status);
            // }
            // console.log('%c clientShare', "color: purple;", typeof clientShare);

            // const url = 'https://hwad.zuimeitianqi.com/dataReport/test/fullScreen.html?t=' + Date.now();
            // url= window.location.href.split('?')[0];
            // window.location.href = url;

            // window.location.reload();

            // 纵向
            const dis = 0.004245395477824045;
            // 上半个和下半个，各370个单位
            // orbitControls.myRotateUp(-dis * 370);
            // orbitControls.myRotateUp(-dis * 1);

            // 横向
            const gammaUnit = 0.003868956469938169;
            // orbitControls.myRotateLeft(gammaUnit * 812);
            // 一半是812个单位，100*16次
        },
        handleToggleOientation() {
            this.orientation = !this.orientation;
        },
        handleHeaderBackClick() {
            const goBack = window.JSInterface && window.JSInterface.goBack;
            // 不能直接调用以上goBack，需按window.JSInterface.goBack调用
            if (goBack) {
                window.JSInterface.goBack();
            } else {
                this.$router.go(-1);
                console.error("no goBack");
            }
        },
        handleHeaderMenuClick() {
            this.toggleHeaderMenu("flex");
        },
        toggleHeaderMenu(type) {
            this.showMenu = type;
        },
        initClientShare() {
            const shareParams = {
                shareTitle: "观天识星",
                shareUrl: window.location.href,
                shareDescription:
                    "轻松看图识别星座，深入探索宇宙之奥秘。快来开启您的星空之旅吧！",
            };
            utils.jsbGetShareResources(JSON.stringify(shareParams));
        },
        handleShareClick() {
            this.toggleHeaderMenu("none");
            utils.jsbClientShare();
        },
        handleRefreshClick() {
            this.toggleHeaderMenu("none");
            window.location.reload();
        },
        handleSearchClick() {
            this.$router.push({
                path: "/searchConstel",
                query: {
                    ...this.$route.query,
                },
            });
        },
        handleToggleArClick() {
            this.toggleHeaderMenu("none");
            this.toggleTopMenu("none");

            this.orientation = !this.orientation;
        },
        handleMenuClick() {
            let type = "flex";
            if (this.showTopMenu === "flex") {
                type = "none";
            }
            this.toggleTopMenu(type);
        },
        handleMenuBtnClick(id) {
            let url = "";
            this.toggleTopMenu("none");
            // 观星、节气、星座、天文现象
            if (id === "stargaze_btn") {
                url = `https://h5.zuimeitianqi.com/page/zh/memberIndex.html`;
            } else if (id === "solar_terms_btn") {
                url = `https://h5.zuimeitianqi.com/page/zh/solarTermList.html`;
            } else if (id === "constels_btn") {
                url = `https://h5.zuimeitianqi.com/page/zh/star.html`;
            } else if (id === "ap_btn") {
                url = `https://h5.zuimeitianqi.com/page/zh/sun.html`;
            }

            var queryUrl = utils.replaceQueryString({
                key: "constelId",
                value: "",
            });
            if (id === "stargaze_btn") {
                queryUrl = utils.replaceQueryString({
                    key: "flowerType",
                    value: "xk",
                    search: queryUrl,
                });
            }
            if (id === "ap_btn") {
                queryUrl += "&tabShow=0";
            }

            window.location.href = url + queryUrl;
        },
        toggleTopMenu(show) {
            this.showTopMenu = show;
        },
        // 绑定设备的方向事件
        bindDeviceOrientation() {
            if (!window.DeviceOrientationEvent) {
                console.error("暂不支持");
            } else {
                if (window.DeviceOrientationEvent.requestPermission) {
                    window.DeviceOrientationEvent.requestPermission()
                        .then((permissionState) => {
                            if (permissionState === "granted") {
                                this.addOrientationEvent();
                            }
                        })
                        .catch((err) => {
                            console.error("err内 %O", err);
                        });
                } else {
                    this.addOrientationEvent();
                }
                console.log("绑定1 :>> ");
            }
            console.log("执行了bindDeviceOrientation");
        },
        addOrientationEvent() {
            window.addEventListener(
                "deviceorientation",
                this.handleOrientation,
                true
            );

            // 启动动画循环
            // requestAnimationFrame((event) => this.animate(event));

            // 设备的移动事件
            // window.addEventListener('devicemotion', this.handleMotion, true);
        },
        handleOrientation(event) {
            // alpha水平左右转（沿z）、beta前后翻转（沿x）、gamma右左翻转（沿y）
            let alpha = event.alpha; // 方位角（0°到360°）
            let beta = event.beta; // 俯仰角（-180°到180°）
            let gamma = event.gamma; // 横滚角（-90°到90°）
            alpha = this.rounded2Num(alpha);
            beta = this.rounded2Num(beta);
            gamma = this.rounded2Num(gamma);
            console.log(event)

            // 手机水平状态时
            // alpha沿z（屏幕中心，垂直于屏幕）轴旋转角度，0~360。
            //   alpha为0°时表示设备的顶部正指北极方向，当设备向左旋转时，alpha将增加。
            // beta沿x（屏幕中心，沿屏幕向右）轴旋转角度，-180~180。
            //   beta为0°时表示设备顶部和底部与地表面的距离是一样的，当设备向前翻转时，beta递增到180°，向后翻转递减到-180°。
            // gamma沿y（屏幕中心，沿屏幕向上）轴旋转角度，-90~90。
            //   gamma等于0°表示设备左右两边与地表面的距离相等，当设备向右翻转时，gamma递增到90°，向左翻转时，递减到-90°。

            // 检查initialOrientation是否已设置
            if (!this.initialOrientation) {
                this.initialOrientation = {
                    alpha: alpha,
                    beta: beta,
                    gamma: gamma,
                };
            }

            // 开启方向事件
            if (this.orientation) {
                if (this.allowOrientation) {
                    this.allowOrientation = false;

                    // 方案八 start---
                    const scheme8Effective = true;
                    if (scheme8Effective) {
                        // 上半个和下半个，各370个单位
                        const betaUnit = 0.004245395477824045;
                        // beta：前转，水平时0，垂直90，屏幕向下180。对应：向下0、垂直π/2、向上π
                        let betaDif = beta - this.beta;
                        if (this.beta === "") {
                            // orbitControls.myRotateUp(betaUnit * -90 * (370 / 90));
                            // this.beta = 0;
                        }
                        if (Math.abs(betaDif) >= 2) {
                            // orbitControls.myRotateUp(betaUnit * betaDif * (370 / 90));
                            this.beta = beta;
                        }

                        const gammaUnit = 0.003868956469938169;
                        let gammaDif = gamma - this.gamma;
                        if (Math.abs(gammaDif) >= 2) {
                            // orbitControls.myRotateLeft(gammaUnit * gammaDif * (810 / 180));
                            this.gamma = gamma;
                        }

                        let alphaDif = alpha - this.alpha;
                        if (Math.abs(alphaDif) >= 2) {
                            this.alpha = alpha;
                        }
                    }
                    // 方案八 end---

                    const { x, y, z } = this.computeDevicePoint(alpha, beta, gamma);
                    // 方案二 start---
                    // 目标：修改OrbitControls的朝向，但不修改它的target。
                    // 结论：1.指向不准 2.修改position的位置
                    const scheme2Effective = false;
                    if (scheme2Effective) {
                        // 保存当前的target位置
                        // const target = orbitControls.target.clone();

                        // 修改相机位置
                        camera.position.set(x, y, z);
                        camera.lookAt(new THREE.Vector3(...this.initTarget)); // 坐标同创建控制器时的target
                        // orbitControls.update(); // 更新orbitControls以反映相机的新位置和方向

                        // 恢复原始的target位置
                        // orbitControls.target.copy(target); // 无效，指向原target，相当于未改变orbitControls朝向。换为下面这行有效。
                        orbitControls.target.copy(new THREE.Vector3(x, y, z));
                    }
                    // 方案二 end---
                } else {
                    // console.log('不允许输出 :>>');
                }
            } else {
                console.log("关闭响应 :>>");
            }
        },
        handleMotion(event) {
            const { acceleration, rotationRate, interval } = event;
            // 设备的加速度（单位：m/s2）
            // 米每平方秒。它表示物体在每秒钟内速度变化的快慢。
            // 它表示物体每秒钟速度改变的量。具体来说，当一个物体的速度每秒增加或减少1米时，它的加速度为1 m/s²。
            // 正值表示加速度方向与速度方向一致，负值表示加速度方向与速度方向相反。
            // 加速度是描述物体运动状态变化的重要物理量，可以用来计算速度、位移和时间等相关参数。
            // 设备围绕其每个轴（x、y、z）旋转的速率（单位：度/秒）
            // interval值为16ms
            let { x, y, z } = acceleration;
            let { alpha, beta, gamma } = rotationRate;

            x = this.rounded2Num(x);
            let xDif = x - this.x;
            if (Math.abs(xDif) > 0) {
                this.x = x;
            }
            y = this.rounded2Num(y);
            let yDif = y - this.y;
            if (Math.abs(yDif) > 0) {
                this.y = y;
            }
            z = this.rounded2Num(z);
            let zDif = z - this.z;
            if (Math.abs(zDif) > 0) {
                this.z = z;
            }

            const rotationRateEfficient = false;
            if (rotationRateEfficient) {
                alpha = this.rounded2Num(alpha);
                let dAlphaDif = alpha - this.dAlpha;
                if (Math.abs(dAlphaDif) >= 2) {
                    this.dAlpha = alpha;
                }
                beta = this.rounded2Num(beta);
                let dBetaDif = beta - this.dBeta;
                if (Math.abs(dBetaDif) >= 2) {
                    this.dBeta = dBeta;
                }
                gamma = this.rounded2Num(gamma);
                let dGammaDif = gamma - this.dGamma;
                if (Math.abs(dGammaDif) >= 2) {
                    this.dGamma = dGamma;
                }
            }
        },
        // 在动画循环函数中更新控制器方向
        animate(event) {
            // 获取设备方向参数
            if (this.initialOrientation) {
                // const alpha = degToRad(event.alpha - this.initialOrientation.alpha);
                // const beta = degToRad(event.beta - this.initialOrientation.beta);
                // const gamma = degToRad(event.gamma - this.initialOrientation.gamma);

                // // 根据设备方向参数调整控制器的方向
                // orbitControls.object.quaternion.setFromEuler(new THREE.Euler(
                //   beta,
                //   alpha,
                //   -gamma,
                //   'YXZ'
                // ));

                if (this.controlsEnable) {
                    // 更新控制器并渲染场景
                    orbitControls.update();
                }
                this.renderer.render(scene, camera);
            }
            // render();

            requestAnimationFrame((event) => this.animate(event));
        },
        // 角度转为弧度
        degToRad(degrees) {
            return (degrees * Math.PI) / 180;
        },
        // 弧度转为角度
        radToDeg(radians) {
            return (radians * 180) / Math.PI;
        },
        // xyz逆运算为经纬度，并将经纬度转换为弧度
        inverseCoordinate(x, y, z) {
            let lon = Math.atan2(z, x);
            let lat = Math.atan2(y, Math.sqrt(x * x + z * z));
            lon = this.radToDeg(lon);
            lat = this.radToDeg(lat);

            return { lon, lat };
        },
        rounded2Num(number) {
            return Math.round(number * 100) / 100;
        },
        // 创建方向label
        createDirectionLabelSprite(position, name, id) {
            const canvas = this.createConstelLabelCanvas(name, undefined, id);
            const texture = new THREE.CanvasTexture(canvas);

            texture.minFilter = THREE.LinearFilter;
            texture.wrapS = THREE.ClampToEdgeWrapping;
            texture.wrapT = THREE.ClampToEdgeWrapping;

            const labelMaterial = new THREE.SpriteMaterial({
                map: texture,
            });

            const label = new THREE.Sprite(labelMaterial);
            label.scale.set(800, 400, 1);

            label.name = `direction：${name}`;
            label.directionLabelId = id;
            scene.add(label);

            let [x, y, z] = position;
            label.position.set(x, y, z);
        },
        // 创建方向图标
        createDirectionIcon(dir) {
            let { name, id, position } = dir;

            const color = "";
            const transparent = true;

            const width = 400;
            const height = 400;
            const iconPos = position;
            const geometry = new THREE.PlaneGeometry(width, height);
            const material = new THREE.MeshBasicMaterial({
                map: new THREE.TextureLoader().load(directionIcon),
                color: color,
                transparent: transparent, // 透明背景
                side: THREE.DoubleSide,
            });
            // 物体网格
            const plane = new THREE.Mesh(geometry, material);
            plane.lookAt(new THREE.Vector3(0, 0, 0));
            plane.position.set(...iconPos);
            plane.translateY(460);
            if (id === "north") {
                plane.translateZ(200); // 沿方向向量前移
            } else if (id === "south") {
                plane.translateY(-800); // 反方向后移
                plane.rotateZ(Math.PI);
            } else if (id === "east") {
                plane.translateX(200); // 右侧平移
            } else if (id === "west") {
                plane.translateX(-200); // 左侧平移
            }
            // plane.name = `方向图标：${name}`;
            plane.dirIconId = id;
            // plane.lookAt(camera.position);
            scene.add(plane);
        },
        isEnglish(str) {
            var englishPattern = /^[A-Za-z]+$/;
            return englishPattern.test(str);
        },
        setWeiXinShare: function () {
            new utils.WeiXinShare({
                title: "观天识星",
                desc: "轻松看天识别星座，深入探索宇宙之奥秘。快来开启您的星空之旅吧！",
                thumb:
                    "https://hwad.zuimeitianqi.com/dataReport/test/constel/constels_share@2x.png",
                link: location.href,
            });
        },
    },
};
</script>
<style scoped lang='scss'>
.constels_page {
    height: 100%;
    width: 100%;
    background: #151a59;
    position: relative;

    .top_content {
        position: absolute;
        width: 100%;
        left: 0;
        top: 0;
    }

    .top_pad {
        height: 24px;
    }

    .controls_container {
        height: 48px;
        padding: 0 16px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        .header_left_col {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            font-size: 20px;
            font-family: HarmonyOS_Sans_SC_Medium;
            color: rgba(255, 255, 255, 0.9);
            line-height: 1;

            .header_back {
                width: 24px;
                height: 24px;
                margin-right: 8px;
                background: url("../assets/images/icon/ic_title_return@2x.png") no-repeat;
                background-size: contain;
            }
        }

        .header_right_col {
            width: 24px;
            height: 24px;
            background: url("../assets/images/icon/ic_title_menu@2x.png") no-repeat;
            background-size: contain;

            .menu_list {
                flex-direction: column;
                justify-content: flex-start;
                position: absolute;
                right: 10px;
                bottom: -8px;
                z-index: 10;
                width: 54px;
                padding: 4px 10px;
                box-sizing: border-box;
                border-radius: 8px;
                background-color: rgba(240, 242, 245, 1);

                .menu_item {
                    position: relative;
                    padding: 10px 0;
                    font-size: 12px;
                    font-family: HarmonyOS_Sans_SC_Medium;
                    color: rgba(0, 0, 0, 0.8);
                    line-height: 1;
                    text-align: center;
                }
            }

            .menu_item:not(:last-child)::after {
                content: " ";
                width: 200%;
                height: 200%;
                position: absolute;
                top: 0;
                left: 0;
                border-bottom: 0.5px solid rgba(0, 0, 0, 0.6);
                transform: scale(0.5);
                transform-origin: 0 0;
                box-sizing: border-box;
            }
        }
    }

    #constel_canvas {
        height: 100%;
        width: 100%;
    }

    .test_btns_container {
        position: absolute;
        left: 0;
        bottom: 100px;
        z-index: 10;

        .orientation_btn {
            color: #fff;
        }
    }

    .search_btn_container {
        width: calc(100% - 32px);
        margin: 0 auto;
        padding: 14px 0 0 0;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;

        .search_input_col {
            flex-grow: 1;
            padding: 0 0 0 10px;
            box-sizing: border-box;
            height: 40px;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            background: rgba(255, 255, 255, 0.1);
            border-radius: 12px;
            backdrop-filter: blur(1px);

            .search_icon {
                width: 20px;
                height: 20px;
                background: url("../assets/images/icon/ic_star_search@2x.png") no-repeat;
                background-size: contain;
            }

            .search_text {
                font-size: 14px;
                font-family: HarmonyOS_Sans_SC;
                color: rgba(255, 255, 255, 0.6);
                line-height: 1;
                margin-left: 12px;
            }
        }

        .search_input_col::after {
            content: " ";
            width: 200%;
            height: 200%;
            position: absolute;
            top: 0;
            left: 0;
            border: 1px solid rgba(255, 255, 255, 0.2);
            transform: scale(0.5);
            transform-origin: 0 0;
            box-sizing: border-box;
            border-radius: 24px;
        }

        .ar_btn {
            width: 40px;
            height: 40px;
            margin-left: 6px;
            position: relative;
            background: url("../assets/images/constels/icon/ic_ar_off@2x.png") no-repeat;
            background-size: 48px 48px;
            background-position: -4px -4px;
        }

        .allow_ar {
            background: url("../assets/images/constels/icon/ic_ar_on@2x.png") no-repeat;
            background-size: 48px 48px;
            background-position: -4px -4px;
        }

        .menu_btn {
            width: 40px;
            height: 40px;
            margin-left: 6px;
            position: relative;
            background: url("../assets/images/constels/icon/ic_compass_on@2x.png") no-repeat;
            background-size: 48px 48px;
            background-position: -4px -4px;
        }
    }

    .constel_info_popup_container {
        position: absolute;
        right: 0;
        bottom: 190px;
        width: 220px;
        padding: 22px 14px 18px 18px;
        box-sizing: border-box;
        background: url("../assets/images/constels/background/bg_star_info@2x.png") no-repeat;
        background-size: 100% 100%;

        .close_info_icon {
            position: absolute;
            right: 8px;
            top: 12px;
            width: 24px;
            height: 24px;
            background: url("../assets/images/icon/btn_ad_close@2x.png") no-repeat;
            background-size: 100% 100%;
        }

        .info_header {
            font-size: 24px;
            font-family: HarmonyOS_Sans_SC_Medium;
            color: rgba(0, 218, 255, 0.9);
            line-height: 1;
        }

        .latin_name_row {
            margin: 8px 0 0 0;
            font-size: 18px;
            font-family: HarmonyOS_Sans_SC_Medium;
            color: rgba(63, 227, 255, 0.6);
            line-height: 1;
        }

        .constel_info_list {
            margin-top: 12px;
        }

        .info_row {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            line-height: 2;

            .info_label {
                min-width: 50px;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                font-size: 14px;
                font-family: HarmonyOS_Sans_SC;
                color: rgba(63, 227, 255, 0.6);
            }

            .info_content {
                font-size: 14px;
                font-family: HarmonyOS_Sans_SC_Medium;
                color: rgba(63, 227, 255, 0.9);
            }
        }

        .view_more_btn {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            width: 136px;
            padding: 8px 0;
            margin: 10px auto 0;
            background: rgba(255, 255, 255, 0.2);
            border-radius: 16px;

            .btn_text {
                font-size: 14px;
                font-family: HarmonyOS_Sans_SC;
                color: rgba(63, 227, 255, 0.6);
                line-height: 1;
            }

            .btn_icon {
                width: 12px;
                height: 12px;
                margin-left: 4px;
                background: url("../assets/images/icon/ic_arrow_more_blue@2x.png") no-repeat;
                background-size: contain;
            }
        }
    }

    .bottom_btn_container {
        position: absolute;
        right: 4px;
        top: 48px;
        background: #ffffff;
        border-radius: 16px;
        padding: 6px 16px 6px 12px;
        display: none;
        flex-direction: column;
        justify-content: flex-start;

        li {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;

            .icon {
                width: 24px;
                height: 24px;
                margin-right: 12px;
            }

            .label {
                position: relative;
                padding: 14px 0;
                flex-grow: 1;
                font-size: 16px;
                font-family: HarmonyOS_Sans_SC;
                color: rgba(0, 0, 0, 0.9);
                line-height: 1;
                white-space: nowrap;
            }

            .label::after {
                content: " ";
                width: 200%;
                height: 200%;
                position: absolute;
                top: 0;
                left: 0;
                border-bottom: 0.5px solid rgba(0, 0, 0, 0.1);
                transform: scale(0.5);
                transform-origin: 0 0;
                box-sizing: border-box;
            }
        }

        .stargaze_btn .icon {
            background: url("../assets/images/constels/icon/ic_starMap_star@2x.png") no-repeat;
            background-size: contain;
        }

        .solar_terms_btn .icon {
            background: url("../assets/images/constels/icon/ic_starmap_solar_terms@2x.png") no-repeat;
            background-size: contain;
        }

        .constels_btn .icon {
            background: url("../assets/images/constels/icon/ic_starMap_constellation@2x.png") no-repeat;
            background-size: contain;
        }

        .ap_btn .icon {
            background: url("../assets/images/constels/icon/ic_starMap_astronomical@2x.png") no-repeat;
            background-size: contain;
        }
    }

    .dialog {
        height: 48px;
        background: rgba(0, 0, 0, 0.9);
        border-radius: 26px;
        font-size: 16px;
        font-family: HarmonyOS_Sans_SC;
        color: rgba(255, 255, 255, 0.9);
        line-height: 48px;
        position: fixed;
        top: 24%;
        left: 50%;
        padding: 0 18px;
        transform: translate(-50%, -50%);
    }
}

#direction {
    position: absolute;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 16px;
    color: #fff;
}
</style>
